import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/1c2d2ee2/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const MdxIcon = makeShortcode("MdxIcon");
const ArtDirection = makeShortcode("ArtDirection");
const Caption = makeShortcode("Caption");
const Title = makeShortcode("Title");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`The color palette for data visualizations is a select subset of the IBM Design Language color palette. It is designed to maximize accessibility and harmony within a page.`}</p>
    </PageDescription>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` This guidance is a work in progress. To see our roadmap, make feature requests, or contribute, please go to carbon-charts `}<a parentName="p" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts"
        }}>{`GitHub repository`}</a>{`.`}</p>
    </InlineNotification>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Categorical palettes</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Sequential palettes</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Alert palette</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Gradient use</AnchorLink>
    </AnchorLinks>
    <h2>{`Resources`}</h2>
    <Row className="resource-card-group" mdxType="Row">
  <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
    <ResourceCard subTitle="Data visualization color palettes (IBM internal link)" href="https://ibm.box.com/s/1rvfetsgovxoj4660suz5sa2tgqizlvy" actionIcon="download" mdxType="ResourceCard">
      <MdxIcon name="sketch" mdxType="MdxIcon" />
    </ResourceCard>
  </Column>
    </Row>
    <h2>{`Categorical palettes`}</h2>
    <p>{`Categorical (or qualitative) palettes are best when you want to distinguish discrete categories of data that do not have an inherent correlation.`}</p>
    <p>{`The colors of this palette should be applied in sequence strictly as described below. The sequence is carefully curated to maximize contrast between neighboring colors to help with visual differentiation.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "469.44444444444446%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/4316b1cdceb177affe915d649a08008a/a5df1/palettes-14catsm.png",
              "srcSet": ["/static/4316b1cdceb177affe915d649a08008a/7fc1e/palettes-14catsm.png 288w", "/static/4316b1cdceb177affe915d649a08008a/a5df1/palettes-14catsm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "141.44736842105263%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/ade68799c87040a282be10f7f9578551/3cbba/palettes-14cat.png",
              "srcSet": ["/static/ade68799c87040a282be10f7f9578551/7fc1e/palettes-14cat.png 288w", "/static/ade68799c87040a282be10f7f9578551/a5df1/palettes-14cat.png 576w", "/static/ade68799c87040a282be10f7f9578551/3cbba/palettes-14cat.png 1152w", "/static/ade68799c87040a282be10f7f9578551/92c65/palettes-14cat.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "141.44736842105263%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/ade68799c87040a282be10f7f9578551/3cbba/palettes-14cat.png",
              "srcSet": ["/static/ade68799c87040a282be10f7f9578551/7fc1e/palettes-14cat.png 288w", "/static/ade68799c87040a282be10f7f9578551/a5df1/palettes-14cat.png 576w", "/static/ade68799c87040a282be10f7f9578551/3cbba/palettes-14cat.png 1152w", "/static/ade68799c87040a282be10f7f9578551/92c65/palettes-14cat.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
        <Caption mdxType="Caption">
          <p>{`Complete default categorical palette in light and dark themes`}</p>
        </Caption>
      </Column>
    </Row>
    <p>{`You can override the categorical sequence with one of the following palettes if the exact number of data categories is predictable.`}</p>
    <h3>{`Light theme alternatives`}</h3>
    <Title mdxType="Title">1-Color</Title>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.888888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAABuklEQVQ4y5VSv0vDUBDOKO4FwX9BwUkcddTNioMVRxc7dnHW0cUOBZc6FOzkJII4iVJFjaDVNtoG0aS2NTQa2pg25tfnew9Ta7W1fnB5x+W77929O87zPPhwie+1GQP1WzidePTk6Of5ScarUqR0tMMnN+p1lAoFmIaB3+DzmGC6ZOBEesNNxYJl27CJmabJzCe+6jqOslkc53KQVBW2ZbH/jUYDrut+VWgT/nhcRN+ajOGEhnupgPOzU2QyWeRIsi+YIn4gHAY3O4tIMolHUQR/cQFBEJhwU9Ai4iObZXCrBQxuVFBUVIj5HG7v7qAoSrOlvXQaXDAIbnISi/E41HIZWSImEmFaZVPQcT2sHOtY2NUQOaji3SY3eC5r3XEcNgCKa1nGXCyGmWgUiVSKxSzSNn2eb0PBX2iddlfa51Dog6pqBS8vKvzloLHfVoLGmXVbG+o8SM94kBVoNZMkeD9u9boItFfPme8OQsuHGJhIYjS0C+E2j6urS/A8D0mSOiZ2AhMcmt4GF1hH/2gCj3KRrEKGrYOmaf8XtB0XU0v7pMItjM3voKob0PUaMZ1NsLX1ngR7nV6v+AAivc6u7zv3kQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/090695ad8d8ffde9d026999612420791/a5df1/alts-light-1sm.png",
              "srcSet": ["/static/090695ad8d8ffde9d026999612420791/7fc1e/alts-light-1sm.png 288w", "/static/090695ad8d8ffde9d026999612420791/a5df1/alts-light-1sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.789473684210527%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAl0lEQVQI122MQQqCQABFPWIE0QlatI7uIR7CRdAqCIqgE7SxIFu4UZKgGRiNatQZX2UQFj34f/EWzzGlBlvQxhoDr7Wdtc/TX66ua35x/EAxmAvS9IiUspHbOKbjumzCEHkWjbvrit5ohT/boeQJXZR/o85kf2O4VEghyPP8HUwSup5HEEVcsuwT7I/XTBcH9FVRVuZv8AERreCzZv7S6QAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/7a5e1d8a6423a9a5cc13681d6924c9ef/3cbba/alts-light-1.png",
              "srcSet": ["/static/7a5e1d8a6423a9a5cc13681d6924c9ef/7fc1e/alts-light-1.png 288w", "/static/7a5e1d8a6423a9a5cc13681d6924c9ef/a5df1/alts-light-1.png 576w", "/static/7a5e1d8a6423a9a5cc13681d6924c9ef/3cbba/alts-light-1.png 1152w", "/static/7a5e1d8a6423a9a5cc13681d6924c9ef/92c65/alts-light-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.789473684210527%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAl0lEQVQI122MQQqCQABFPWIE0QlatI7uIR7CRdAqCIqgE7SxIFu4UZKgGRiNatQZX2UQFj34f/EWzzGlBlvQxhoDr7Wdtc/TX66ua35x/EAxmAvS9IiUspHbOKbjumzCEHkWjbvrit5ohT/boeQJXZR/o85kf2O4VEghyPP8HUwSup5HEEVcsuwT7I/XTBcH9FVRVuZv8AERreCzZv7S6QAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/7a5e1d8a6423a9a5cc13681d6924c9ef/3cbba/alts-light-1.png",
              "srcSet": ["/static/7a5e1d8a6423a9a5cc13681d6924c9ef/7fc1e/alts-light-1.png 288w", "/static/7a5e1d8a6423a9a5cc13681d6924c9ef/a5df1/alts-light-1.png 576w", "/static/7a5e1d8a6423a9a5cc13681d6924c9ef/3cbba/alts-light-1.png 1152w", "/static/7a5e1d8a6423a9a5cc13681d6924c9ef/92c65/alts-light-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <Title mdxType="Title">2-Color</Title>
    <Row mdxType="Row">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "140.2777777777778%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAAACXBIWXMAAAsSAAALEgHS3X78AAAEOUlEQVRIx51WXWyTVRj+LoxX3mACMxol6o1REjWaiC7ZMjFmFzqDCSqKpmQRjcFdEC+ImTEEFcfEDUiMQUQyGHNTduMYY2PRxUAp7dr15+u6dXRt17Xr+v/7/ffxnLPup107B29y+v2c93vOed73ed9TrlAogBm5aFoB9HndQNGHummo6MPmyJWjP8GFOUQTC9jIkqk45oIeCEqm4vwyKAOcscTguBGBj88in89DFAUIgoBsNgtFVpYAFxS4DQL8ExrSUQV5IQdJlJDL5Yi/uLpDWdDQobNDt30MX71uhs/ng9FohMlkAs/ziEXjzNk2qKGtTsZ3O1UY+lPgpyy4bTDCbDZjdnZ2FVCRNHzbaIbuwX/wdb0Z0WgUMzMz8Hg8bJdLpmH8MvDNi8CxlwHLgIK50B24JqchSdIKGANUFQ0//ejE4ZbbOPW9g21flmU2KH1ZWqLMj0ZwRmfFbwcccOtjZAmZhCRXAshiKJGbZ3vPg/v1JJ4avAyv18vomsbHYbFYEI1EmOPo+XN454H78fZ9HK6ePQObcxK39Hq43e7SHUqahu0XusCdaEfNpW6EQiE4nU4Wv3Q6TT3ZB391nkYDx2EXGdd+OYf5xTB4u4MBqqq6JoYE8EuTEXtGR/CFQV+iKTo0Mk/NMjyC9nffR8eHOrj0t9g7ClTuz2ETViiCVtJd+T1HdxCMLGIhHoW6AWg6mUB43g8xm1oHsk7YQZcHIf4OsqHYCsVlCmrxOZIWYPURSUXzyMmrNKl/SempRO1/N7fj4hMf4ErjYSbSsbExJm6HwwEH7ySeCrpINT180ovHz8bwuzWGGacNk64ppoiSSlFFGf21n+M0V4/eHc2IEJlYrVbYbDakUiko2tLqp4wpcEf94I6H0WXPIOR1w+bgWZbXsuI0RcXIgTb01R/EcPMxljkqaloljFIxVP1TGbzS5UdDdwDXPVlWPTkifCr+kizLgojj7+3Fvm0PobVhFys7y8QE7HY7MpnMSuPquXkDj7UcxLbPPkWf/iY809Owk5D4/f4yYZOdtOx4DrVEsPtrHkEgEGB0afzC4fAKYOfQELimJnBvNuHnkRH4ycITJDS05ksoq4qCzo/249ALL+HE3n2MMq1PSlkhc8tZ7jMY8HxrK3YeOYIhq429y7FWJ5ZmuURLVRpnueb+t8Em4nGkEglWt8vaKtdXtYUqHgEBEqv5xUXki62o0srVAMqNk8nLPYNX8GRvD964PoxgMAiXy4UJkul4PF71w2rGiYTao6TXcT+0YWvPRZZlC2nrtBcmaBjuFlAmgI3XhlDTfQGvXh1gGaaZE8hY2+c2v0NJxSdH/8XTu//A7kOjrJZpOVEd0vPlrgEFUcUzb/0JbksHttZdYoC04CnlZDJ5D5TJIfXax4PYUtuFOt0AE3Q6nSIjc2+UqXMyI5F/DgISaXHDzrwZ+w9BJvbvYNFwbwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/0a3df2ee8350f899ec5104ca7723c303/a5df1/alts-light-2sm.png",
              "srcSet": ["/static/0a3df2ee8350f899ec5104ca7723c303/7fc1e/alts-light-2sm.png 288w", "/static/0a3df2ee8350f899ec5104ca7723c303/a5df1/alts-light-2sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.086206896551724%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAyElEQVQI11WPu4rCQBiFfUEfw2pLn2DB0iAWgvXa2IhoIYiFNuLabDAEL7AbF0HxfiGaOE5mPiep9FTf4fycn5M6eDf8fYhCEl7hsISHFGituczXBGcfpSS7a8TiLFHygVSK2WWPfw/RShMrvo+VKhZcmg3HYMDf8MRXdsB6u0rCZuaT70bHkKTqbPio2QTHLb6QpCst+u4UbR68FRZch+7cS4w3GlG3LEIhEl/PW0x/7IR7kzGldhsis0RE5Mo2v/8bkyj0S+ETYyrbf30Da54AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/b3b3c76c4665dba1d96c052f2054b35a/3cbba/alts-light-2.png",
              "srcSet": ["/static/b3b3c76c4665dba1d96c052f2054b35a/7fc1e/alts-light-2.png 288w", "/static/b3b3c76c4665dba1d96c052f2054b35a/a5df1/alts-light-2.png 576w", "/static/b3b3c76c4665dba1d96c052f2054b35a/3cbba/alts-light-2.png 1152w", "/static/b3b3c76c4665dba1d96c052f2054b35a/0b124/alts-light-2.png 1728w", "/static/b3b3c76c4665dba1d96c052f2054b35a/0c3f5/alts-light-2.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.086206896551724%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAyElEQVQI11WPu4rCQBiFfUEfw2pLn2DB0iAWgvXa2IhoIYiFNuLabDAEL7AbF0HxfiGaOE5mPiep9FTf4fycn5M6eDf8fYhCEl7hsISHFGituczXBGcfpSS7a8TiLFHygVSK2WWPfw/RShMrvo+VKhZcmg3HYMDf8MRXdsB6u0rCZuaT70bHkKTqbPio2QTHLb6QpCst+u4UbR68FRZch+7cS4w3GlG3LEIhEl/PW0x/7IR7kzGldhsis0RE5Mo2v/8bkyj0S+ETYyrbf30Da54AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/b3b3c76c4665dba1d96c052f2054b35a/3cbba/alts-light-2.png",
              "srcSet": ["/static/b3b3c76c4665dba1d96c052f2054b35a/7fc1e/alts-light-2.png 288w", "/static/b3b3c76c4665dba1d96c052f2054b35a/a5df1/alts-light-2.png 576w", "/static/b3b3c76c4665dba1d96c052f2054b35a/3cbba/alts-light-2.png 1152w", "/static/b3b3c76c4665dba1d96c052f2054b35a/0b124/alts-light-2.png 1728w", "/static/b3b3c76c4665dba1d96c052f2054b35a/0c3f5/alts-light-2.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <Title mdxType="Title">3-Color</Title>
    <Row mdxType="Row">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "187.5%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/6bfa1dc2ad13ace3887bb6043a3c2967/a5df1/alts-light-3sm.png",
              "srcSet": ["/static/6bfa1dc2ad13ace3887bb6043a3c2967/7fc1e/alts-light-3sm.png 288w", "/static/6bfa1dc2ad13ace3887bb6043a3c2967/a5df1/alts-light-3sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "19.827586206896548%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAAAsSAAALEgHS3X78AAAA/UlEQVQY01WOzU7CYBBFeVJfQlnojidATFzIio0QF00MG0PYQFBSSbSa2JLQYAJI/0BDsRTbfu3xa40LZjNzc+eemVLgpISbGJEJ9n6AZ34QRRFCJHw7GaEvPVKyzy1iPGe7CxBJwqOuY3keqRDklWVZ0UvKjcOg905MhK+ZPJdrLCxLLiS0W0vUwVQC91hjj15DxXZt6aWcHrfodkZEcXgIrFSvUNp3JFJsnjReyme463VhHp1f0+zey0nQfws5qc/4Wtl5nEpVoz+cyA9/DoFmo8Ps4ZVcznWD29oFQfh39bJpoGqLAuBMdoyUJfsozCX1qYG+ciFNi+w/8BeinyN0qGYVCgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/9e9d561d8842567ec925003ba2a4eb60/3cbba/alts-light-3.png",
              "srcSet": ["/static/9e9d561d8842567ec925003ba2a4eb60/7fc1e/alts-light-3.png 288w", "/static/9e9d561d8842567ec925003ba2a4eb60/a5df1/alts-light-3.png 576w", "/static/9e9d561d8842567ec925003ba2a4eb60/3cbba/alts-light-3.png 1152w", "/static/9e9d561d8842567ec925003ba2a4eb60/0b124/alts-light-3.png 1728w", "/static/9e9d561d8842567ec925003ba2a4eb60/0c3f5/alts-light-3.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "19.827586206896548%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAAAsSAAALEgHS3X78AAAA/UlEQVQY01WOzU7CYBBFeVJfQlnojidATFzIio0QF00MG0PYQFBSSbSa2JLQYAJI/0BDsRTbfu3xa40LZjNzc+eemVLgpISbGJEJ9n6AZ34QRRFCJHw7GaEvPVKyzy1iPGe7CxBJwqOuY3keqRDklWVZ0UvKjcOg905MhK+ZPJdrLCxLLiS0W0vUwVQC91hjj15DxXZt6aWcHrfodkZEcXgIrFSvUNp3JFJsnjReyme463VhHp1f0+zey0nQfws5qc/4Wtl5nEpVoz+cyA9/DoFmo8Ps4ZVcznWD29oFQfh39bJpoGqLAuBMdoyUJfsozCX1qYG+ciFNi+w/8BeinyN0qGYVCgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/9e9d561d8842567ec925003ba2a4eb60/3cbba/alts-light-3.png",
              "srcSet": ["/static/9e9d561d8842567ec925003ba2a4eb60/7fc1e/alts-light-3.png 288w", "/static/9e9d561d8842567ec925003ba2a4eb60/a5df1/alts-light-3.png 576w", "/static/9e9d561d8842567ec925003ba2a4eb60/3cbba/alts-light-3.png 1152w", "/static/9e9d561d8842567ec925003ba2a4eb60/0b124/alts-light-3.png 1728w", "/static/9e9d561d8842567ec925003ba2a4eb60/0c3f5/alts-light-3.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <Title mdxType="Title">4-Color</Title>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.55555555555554%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAfCAYAAADnTu3OAAAACXBIWXMAAAsSAAALEgHS3X78AAAEm0lEQVRIx51WbUxbVRi+8Yf/3A/iAokxGhPjsuiPJUaNAb+2ZAghJurUxR84mfjBDC5uolvclCxZzBLJPsQlDJ04QAY40FEUFpZ164CW9ZtSCh1QaJu2XNq1lN57e+99POeUMsqAUU9ye2/Pfc/T5/163nKqqoItclMVBfT7ald6Kcra7+mdox8zAT8CYR7rrUg0DK9/CqIcX/V9GpRTyS/6hpzwXDNh1uKGIAhIJBJYWFhgz/Pz84w+71+A7XoALkMY4WCC2ND3IuLxOLNfYphMiPj3raOoe6gIl56vwMTEBHp7ezEwMAC73Q6nc5SYJnGzPYBPt17H3ie06Gu+jRGXFfpBA8xmMyYnJ+8CyqKE1vxKnHpgB/7Y9gnC4TDGxsbgcrkYy/S62uBH2SM6lD/WD127D0Hei1GnC8FgMMNtTknKsB0+C92uQzAdPA1RFCGIAgOTZZklga7+nml8vbsXR0qvwqTzkR0ZSSnJQqKQZC4BklMIVHyBxM4SoPIAXISd3mCA0WhENBpFOr91bd14cFsxuC07UN/WBZfTAbPFgqGhIRbru4DJJBIfV0IuKAT27kMoFIJ9eJi5TdmmGZ463wFucz643ALUt2gwGwowm6mpqUyGKgH0Vx/HRGk5vN9WM5Ak2RNI5qjL8qJxS18/nvmgCs9+dAiafiPbSxBm1D4NxgBFcvDYrvfw5qYcfPliAUvGoF4Pk8mU4fI5hx2b6s/i4bZmtLhJ0qxWDJLQUJYZgBL5lYqntiCf47AnN4+5TEFHR0fZcxrwuNkI7scfwNWeRK3NitCUBw6nE9PT05mdIpNMnfnwAL56rhg17+9LZXnRFeq6vBjDy65x7LzQiqLGVvTdnqQ9CFGSmN3y9iOdAnTXiuj4HtD9AhZkq9XCCpZmmg/NMkOhx4bI7lqgvAnzfXbcGrbi5o0bcDgczM7j8aQAlSTQXBXD6bcFtFaprFBtdhtzWSIMaJ3SFW03YPKFagRePYE73Ra4fR6YjSbWWdSOJjAFKKvQXwR6TqrobwRzgfamREKRkpeUK5J+ArGjnYhW/wXB4oGg0sKWGFhGp6zQjHsUhMVGVddVoswYkofZYAjhWX7poLKoi8tlaS2dXFUPvaQ8vCT4cUJ/JUCK99oAKxcnkc3CzkvIaTiPl7q74PP5WOZoYfM8v+bBtRYnEvceb/gVXM0J5LU0wev1MjAr6YRIJJI9oEQAX9f8g7zfL2D75S6WNYlJmLhUClkBCqKMsiNaPFl8ESWfX4Hb7cbIyAgsRJrS4pkVYEKQsfWNNnA5Ndj8chOTc+oyvZa7vFFQTiKdUPRZD3JfacRrZRpW2HTwpEUza4a0lzU/82j7TsC1c2BJGXePM8WhiaEzJhuWHOkgNFVF8NM7Iv78BvD7/aTZbzFxmJubu0dA7wuoEEAtUZmOY2SyEYa0j2PzsYwezcZtNka1++vIKD2IK6U1CAQCbB5TJU6P0+Us7wtIB33n9v04wxWg5ek9mJmZgVarhU6nY/GkY5IK7YYBFSJTXSWH8duj7+Lvwqqlvx+xWOz/uUwNE/wdxP08FkKRdaVpI6D/AUBD1FOKt44IAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/2968aec8b5d43644b2619c209794c520/a5df1/alts-light-4sm.png",
              "srcSet": ["/static/2968aec8b5d43644b2619c209794c520/7fc1e/alts-light-4sm.png 288w", "/static/2968aec8b5d43644b2619c209794c520/a5df1/alts-light-4sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.66447368421053%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsSAAALEgHS3X78AAABhElEQVQoz3WSvWrbYBSGNeUeCrmADL6AErrlCkqHDgEPHV1KWyh46hC6F0NpyJS0QzdncjdjSE08JBlMmqDGbYktyZ9k/Vq1ndiyJD+R5eCkrnvgg8PLex7ec/ikmL9rMpkQTq6n3Z02fWEEwfgf72JJ1Tc76G1Bs9ViMBik018/qNSKAr2jYll2apQdm82DMmdtDafTIb6FLUKlYiaL1lIwpqY4Tg1bT4/49O47hqXgdf+kxkNhsPJxl2rjJ46uE0bRciDPcqjNJpbjpMIUuv74OS/eFrBMA9fzZ8C6gZTZoVKTcSyRAOM58D5U+rz+KEnYwnbdueHh+21e7ZdwkyS9/lWqN+Qeuewv5HMToSuMhsHyhJura+hC0DHN2cqJuFEqka/V8BJg15+tbP8OKb0eo8gupmMQjILlCYt50FSBpinzu3gvv+BvV7hQLxGqlmrmyQV7D57w49sxl20Fv+svB8oVGA5HRPeOPCrLBHWFYTQmvtX7bZvTQpGB6RHG0X+/zQ1DoEtdDX/FKgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/f2ca41a87eb448cd0db0a71cc39c6f2a/3cbba/alts-light-4.png",
              "srcSet": ["/static/f2ca41a87eb448cd0db0a71cc39c6f2a/7fc1e/alts-light-4.png 288w", "/static/f2ca41a87eb448cd0db0a71cc39c6f2a/a5df1/alts-light-4.png 576w", "/static/f2ca41a87eb448cd0db0a71cc39c6f2a/3cbba/alts-light-4.png 1152w", "/static/f2ca41a87eb448cd0db0a71cc39c6f2a/92c65/alts-light-4.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.66447368421053%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsSAAALEgHS3X78AAABhElEQVQoz3WSvWrbYBSGNeUeCrmADL6AErrlCkqHDgEPHV1KWyh46hC6F0NpyJS0QzdncjdjSE08JBlMmqDGbYktyZ9k/Vq1ndiyJD+R5eCkrnvgg8PLex7ec/ikmL9rMpkQTq6n3Z02fWEEwfgf72JJ1Tc76G1Bs9ViMBik018/qNSKAr2jYll2apQdm82DMmdtDafTIb6FLUKlYiaL1lIwpqY4Tg1bT4/49O47hqXgdf+kxkNhsPJxl2rjJ46uE0bRciDPcqjNJpbjpMIUuv74OS/eFrBMA9fzZ8C6gZTZoVKTcSyRAOM58D5U+rz+KEnYwnbdueHh+21e7ZdwkyS9/lWqN+Qeuewv5HMToSuMhsHyhJura+hC0DHN2cqJuFEqka/V8BJg15+tbP8OKb0eo8gupmMQjILlCYt50FSBpinzu3gvv+BvV7hQLxGqlmrmyQV7D57w49sxl20Fv+svB8oVGA5HRPeOPCrLBHWFYTQmvtX7bZvTQpGB6RHG0X+/zQ1DoEtdDX/FKgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/f2ca41a87eb448cd0db0a71cc39c6f2a/3cbba/alts-light-4.png",
              "srcSet": ["/static/f2ca41a87eb448cd0db0a71cc39c6f2a/7fc1e/alts-light-4.png 288w", "/static/f2ca41a87eb448cd0db0a71cc39c6f2a/a5df1/alts-light-4.png 576w", "/static/f2ca41a87eb448cd0db0a71cc39c6f2a/3cbba/alts-light-4.png 1152w", "/static/f2ca41a87eb448cd0db0a71cc39c6f2a/92c65/alts-light-4.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <Title mdxType="Title">5-Color</Title>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "94.44444444444444%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAAAsSAAALEgHS3X78AAADyElEQVQ4y32UX2yTVRjGP0wMt0bihfFGjSzxwogyCDGTRNSgcqMxJmhQZAlLyBIZd7tYEEQI808GukHAtNFswcThBBxBtsXoIA1b/9J139purW23td26GUb/fW2/bz/Pd7612XB6kren7XnynPc5z/u+yvLyMtVlGMuYvx8MEPsKRhcYY10MclfMj2R6mszfaf5v5bL3SSfj6OX8uudVUkkYubuI6siQGM9RLBbRNE1GLpejXC5LYHI+y5AjxrArycxcFq1YEJgS+Xx+bYZlzeBMY4DGp4Zpe81DPJbA5XbhdDoZHx9nfj4jwb0DUR5+0Y6y+QLtNid+7whujxePx1O7VBJWygafv+nio0eHaGsYJTO/wOTkJJFIxLp9RZK9L4TyRJeIc3xl97GYmUGdCDI7O1sjk4S6bnDxyzhHD03Q+VlEytANnZLYS6WSNMpcN50zNLT0s7PlV/puRU17KBStp1krWXzf+cMkG88m2Na7RDyRYOTOHQJC7tTUVC3DnokAG8538FD3d3SpY0TE+Yh4lmAwuMZtRShmmy2JcirFs/Z7zGUyhARIVVUWFhZqhBcnVJTOMygXumj3eZmLxfAHAvJSwzBWvaGQdOCayM4WZm9fDE3INOuuUCig67qsOXMNTEV5xdbNLns3V9SgRbBCUqlUZMiyKQqH9n7TwaaDjez4tE0+8l2fj7GxMTKZTK3OZm6Mcm1LE31P72Pc1o8/pHLrz2G8Xq/ERqNRi1AThHWtrSh79vBIczPJVErKDYfDLC4uivaxMgz/+DvnN+6ma8Or+Dp/4a/UNM6R0X+7XBGyPmj/mueaW3jnZLt0zawrs8BNyVXC6HUHPfWNXNrRxGTfH/K/Qr6wpgatstHKuA6f4/rWQ9x+7wSJeByHw4FPSDELOyDkCFq8g4Mcrq+nqa6O3+x2gsIMj9stlVhzwDJGEl5u+IQOpYGezR8yl0qLDnDLDjAll6VJMGT/nl2KwssiLp/+gul0Wl5qPk/VEJmhUdEZPHCa3peaGdh3El0clkWYkldPElf/DY48v50jL2zn9k8/r0jOS9zqASF6WePsx40cfPIZjr3+hnRrTNSXKuRms9kaOOIucqn1HlePgTpcIBILEQqFCQhsVbYkLIkbWrZspUFI2f/Y48TFG5ql4Pf7SQnHq0sd1vj2/Ry2/eC/WWYqNoHL5SEhOqvafpYpQt6pt9+lycxw91uihzXRo0WZnQW0SnjaD1ePw5XjYtyNGmiVHEtL961KeHAemllquTya6I7/GpyGLjqiZIWhr48x938AzYErqHxZLkcAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/a75d651fd3b2ce058ceabc0df7f2ee98/a5df1/alts-light-5sm.png",
              "srcSet": ["/static/a75d651fd3b2ce058ceabc0df7f2ee98/7fc1e/alts-light-5sm.png 288w", "/static/a75d651fd3b2ce058ceabc0df7f2ee98/a5df1/alts-light-5sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "44.73684210526316%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABTElEQVQoz5XRvU7CUBjG8d6EkxuDiQ7egIuribuDg9G4acJCojdAjJMYB70B0EQGu6ICDgwGRBIRCxoopbSnX5YEbVr68dieGOJGfbfzH355zzmM49rwMMHf8X0XQWBPz0EQIO4wNVZG7uANhBAQRaGx3TWxkbxHtdGDrhH4v2AEz8KZfI5gb/sVojiApus0Vjsq5jazuH3kYKgyIiMORsHMs4WVaxMDQYCmaTTWdBXz7CWK720Y4ebefzY8KpSxlD6BNBxiZI5olFo8LtYO0azUwQ8EfI3H8cHsFYut3RSEcENZkmgkDQ7ni+toFisguhZJU2wmyJ3doLCaAt/nIcsyjR/1OnYSCVRLJSjhu/qeF/u3mXz6GPsLyyHYh2F80qh0HeSSBrgnCYLYg+NM4l/5pfwANnMKy7Jg2w6N3+FTtu4AU3Uwce3YWDQ/Asqgc07XvtYAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/ef14ae79c9b81657626060e006fe5ed8/3cbba/alts-light-5.png",
              "srcSet": ["/static/ef14ae79c9b81657626060e006fe5ed8/7fc1e/alts-light-5.png 288w", "/static/ef14ae79c9b81657626060e006fe5ed8/a5df1/alts-light-5.png 576w", "/static/ef14ae79c9b81657626060e006fe5ed8/3cbba/alts-light-5.png 1152w", "/static/ef14ae79c9b81657626060e006fe5ed8/92c65/alts-light-5.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "44.73684210526316%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABTElEQVQoz5XRvU7CUBjG8d6EkxuDiQ7egIuribuDg9G4acJCojdAjJMYB70B0EQGu6ICDgwGRBIRCxoopbSnX5YEbVr68dieGOJGfbfzH355zzmM49rwMMHf8X0XQWBPz0EQIO4wNVZG7uANhBAQRaGx3TWxkbxHtdGDrhH4v2AEz8KZfI5gb/sVojiApus0Vjsq5jazuH3kYKgyIiMORsHMs4WVaxMDQYCmaTTWdBXz7CWK720Y4ebefzY8KpSxlD6BNBxiZI5olFo8LtYO0azUwQ8EfI3H8cHsFYut3RSEcENZkmgkDQ7ni+toFisguhZJU2wmyJ3doLCaAt/nIcsyjR/1OnYSCVRLJSjhu/qeF/u3mXz6GPsLyyHYh2F80qh0HeSSBrgnCYLYg+NM4l/5pfwANnMKy7Jg2w6N3+FTtu4AU3Uwce3YWDQ/Asqgc07XvtYAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/ef14ae79c9b81657626060e006fe5ed8/3cbba/alts-light-5.png",
              "srcSet": ["/static/ef14ae79c9b81657626060e006fe5ed8/7fc1e/alts-light-5.png 288w", "/static/ef14ae79c9b81657626060e006fe5ed8/a5df1/alts-light-5.png 576w", "/static/ef14ae79c9b81657626060e006fe5ed8/3cbba/alts-light-5.png 1152w", "/static/ef14ae79c9b81657626060e006fe5ed8/92c65/alts-light-5.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h3>{`Dark theme alternatives`}</h3>
    <Title mdxType="Title">1-Color</Title>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.888888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACGElEQVQ4y5VTO2/TUBj1QhnIy762r19pnQqahyoncZoUCMZ5CcKCBL+CDdgQEgJViIEBiQEhJOgeylLB1ImqSAxVEQsbIxL9A50P97NjkxSBynD8Xd97vnO/15V0XQdTtQg656D/WWiallpFVaHR+hhnlifRx6+vol4rQ1cKUMlJHJIl0DlZd3ERF3wfK0uu4LH0POEnohLdVlofYTm4DtvvwTAtmKYJy7Jg23YckXDipRLsXg/6pS7UagUOnTsOHAEuMksj5JaD8sYO/G1gdfMHGq02ro2vIggCdLvCWRB5oQC5exGn3k2w8GkX2bu3EXY6uDIeIwzD6OIkG0kXEXmvvmN9D6hPjlDzGgiEULvdiYlUo1wOymiE05/3sPD1ANn793De8xD2++gIYcrmdw25gXO3nqP28ANW7myCWzYMrqdpaNSoggzW8pHZeITMk8eQb96AwRhMKy7PXFOi7uUyULJnoMn5WGSKtINkKaV8PoaizPHmmkKRVKpVlCuVuAFUM7HHpyMUkcmJ1hQ14V9jQwu/2UazsYaSezYSUkQEyjSKhJzMXzqHM3uzwpIlavbswVt8nPzE1ssvaPlronOXMRgMMBwO4Yniy7L8R0R/QyS4/eYbDg+A/fdHaNSb0Sj0e30Ui8W5GTuRoGGYeP10B7tbh5i82BdpL8N1XSyJF3G84CcSjN8yA2OKGM74STHGIvyvGOEXwnJ5bJ/4B7cAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/bb345be8afe7572c09ec356e17f54cff/a5df1/alts-dark-1sm.png",
              "srcSet": ["/static/bb345be8afe7572c09ec356e17f54cff/7fc1e/alts-dark-1sm.png 288w", "/static/bb345be8afe7572c09ec356e17f54cff/a5df1/alts-dark-1sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.789473684210527%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAv0lEQVQI11WOsWrCUBhGXYVCzP3vvblJjIlauVaqoF0c2jeog+DgKgi+gdCxYMW59B0Eh+IbHjUQweHw/5zh8NWyJCa1QhiGaK0xxpA4R3FFrk5EShdFES62KAlRSpXOWlve6r9Ra882DL5OjEZDnns9dBBg3iY8HX7wH++8+j5KC2nS5G93Zjlf8zLwFHlRDqhC92D+ucFvj/S9J2u1MEEDmYyp73d0p1N8p4vcgmnG7/c/i9mKvMhwLn5YVnEBtt9XGw9ZmeEAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/d0acd30857e67a200b301151089cf212/3cbba/alts-dark-1.png",
              "srcSet": ["/static/d0acd30857e67a200b301151089cf212/7fc1e/alts-dark-1.png 288w", "/static/d0acd30857e67a200b301151089cf212/a5df1/alts-dark-1.png 576w", "/static/d0acd30857e67a200b301151089cf212/3cbba/alts-dark-1.png 1152w", "/static/d0acd30857e67a200b301151089cf212/92c65/alts-dark-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.789473684210527%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAv0lEQVQI11WOsWrCUBhGXYVCzP3vvblJjIlauVaqoF0c2jeog+DgKgi+gdCxYMW59B0Eh+IbHjUQweHw/5zh8NWyJCa1QhiGaK0xxpA4R3FFrk5EShdFES62KAlRSpXOWlve6r9Ra882DL5OjEZDnns9dBBg3iY8HX7wH++8+j5KC2nS5G93Zjlf8zLwFHlRDqhC92D+ucFvj/S9J2u1MEEDmYyp73d0p1N8p4vcgmnG7/c/i9mKvMhwLn5YVnEBtt9XGw9ZmeEAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/d0acd30857e67a200b301151089cf212/3cbba/alts-dark-1.png",
              "srcSet": ["/static/d0acd30857e67a200b301151089cf212/7fc1e/alts-dark-1.png 288w", "/static/d0acd30857e67a200b301151089cf212/a5df1/alts-dark-1.png 576w", "/static/d0acd30857e67a200b301151089cf212/3cbba/alts-dark-1.png 1152w", "/static/d0acd30857e67a200b301151089cf212/92c65/alts-dark-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <Title mdxType="Title">2-Color</Title>
    <Row mdxType="Row">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "140.2777777777778%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAAACXBIWXMAAAsSAAALEgHS3X78AAAEyUlEQVRIx41Va0xbZRhmbjNYoLdzTs/pDUrpaaH0AoVS61oobaGjg8YE5mDCkDi3RWEYZ0YcGJx4WUxmzIzGLdMEE0Gd27IlXuP8YxSjiLeEaPTHtl8m018z0cQfj+/3QctlzNDkPef0fE+e8z7v+7zfV2QymSCKEiTRBNkkg/2/NWhdIpwg0bNyG4yJMBKK2ENdyAdvQIUgaYlchCAIhTsDCYIIl9uJUNgPu0OBIBr4ej7yOMZFhDJCVRlE1G747ClYLBaUl5fDZrPxu9Vq4wQuexB3u3vQUNmFCnM17OU22GjNbrejoqJiJUNZtOLJzE841Q6MRX6DS3Whvb0d2ewuJBIJ1AXrUaK9E7nQE3g1C5xsBhLuQwhHg8h2dCKVSqGlpYUnwgkVExGGf8HpODDZeJ1/LRqNoincBFmWCSRDJxQj45nAiwngBSJsdj0MX52KeKwZVVVV0Ov1XDqXLJvM6Ei8ht5dn6Kz9XWYzWYuw2q18mAl0QmlSHn6MJX4BJMt7+MeVxcUmwlWi41nxnCsRDxDif5se+k5bPn8A9zx1hk4HA6Sm+VyQ6EQdV9EiUGHkVgO/4y/Axy/jAPRLMKxKHb39CCdTnPJkUhkmZC+oHlzGsXff4fi8++hsrISCQI0NzfD5/NBJrsU68swnuoHnv+S4guMxLuh+mo4zu/3r+2ypCjQHR5G2bNT0D46WvAUqx8Pklxm1GN3KIlL9z+Fc70T6PBH+bu8b/NkSz6ki1hSAkmjgazV8ZfrQyaw1qDHtlINinVlMIhCgWA12VJTKItqvw9qbQ2MsrQhIZPkqnKiPlALZwUVXxT45KzGrJmUWDCMlmATAg73mjFakq6QJQQ4qrzwhdOorIlAtlTwcVw/djxDu9mCS32TuDl2HgsHX0Z1dTVyuRw3dywWQ2ZnB1SnHY7IA4hP/I7k1E2oO4aQbt1BTkgik8nwiSr40KZY8OvwWeDEV7jx2Cy3DSNiVnA6nZBpXTRoUJMZR+YUeLgTwwjXe5FMtXFrrcnQTJIuDD2NxSNv4PLQM7yzCnWemZtPCnVS0GngTTyEtvFFJI8uQI3cB0UywEKzzLBrCJnDL8zO4I/r1zD32RWoqsrltra2wuv1cqCurBS5gf14e+EaLi7eQMeefagL+LmSeDzOy2Q0GlcIf56fB/v9efUqN3ZbWxsaGhqWfEgZlGruQv/oMcz9DXz9L9C9fwRBXy3h2lFfX1/Ibkkyze6709P4cW4OF2dmOAmbT/aee5AItaUl6Nz7IE5f+QGvfPgNWrt6YGKdp3ozyfmGLI0eXQwGAwyUsrjsKQZYb1jut+X3eczqkVu1wZpQ7fHATbWTlxfyY3cL4Tojr/fgCiFtAp7aWii087BFVmAWq6VsdH5sdK4UCXQxDg5g6+gj2NrfxzfYZDLJd5tAIMBl3e5Q2piQpGnHHkfRyRMoOjLKzZwkyzDCxsbGQpabJpSIcPtgP7YQ2fahfby7tuUdmNXx/2RvSKhYzdh5Yi8GPhrDvWcPFEYvWBfkpvVQw/Km3RyhzYzBj4/i2F9ncHD+OJxk7HQqzU8zNin502zThLJZwZ7ZYRz6dgq95w5zAjYtbAQZIN+UTUtmF4uDDm0XHeq0TeUNy2SuN+1m4j9z9GCK45DBnQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/0685ddbc1a62ac16bf87c54b9eb9d029/a5df1/alts-dark-2sm.png",
              "srcSet": ["/static/0685ddbc1a62ac16bf87c54b9eb9d029/7fc1e/alts-dark-2sm.png 288w", "/static/0685ddbc1a62ac16bf87c54b9eb9d029/a5df1/alts-dark-2sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.086206896551724%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAA1UlEQVQI11XOP0/CUByFYUY1DhLa29+9t1eqLbEEgtABE+OfVpImhhAXJ6Ksxmh0Yemim1/BEXY+5Et1MQ5nOicnT6NvxxzblEB7ONMhcWcYI6ggYBz3iF2EiMK0U8I4w+ifTvCSE3QYIvXO932UUr9plJNvJsUzNmpykcyoihWDUR9tDJvXLxbTewI5YFg+MX1b0+1EKGtx7wtOL89ph46W5/0d7j/McTcFfqvJdZrxUT5yeFSrasVnVVHkOXu7O1zd3jF/WaJrkVhNvpzRzXqIkn/CLVsUW7UEbF3UAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/aa7be887e76fef4dd29e89f779a0c12a/3cbba/alts-dark-2.png",
              "srcSet": ["/static/aa7be887e76fef4dd29e89f779a0c12a/7fc1e/alts-dark-2.png 288w", "/static/aa7be887e76fef4dd29e89f779a0c12a/a5df1/alts-dark-2.png 576w", "/static/aa7be887e76fef4dd29e89f779a0c12a/3cbba/alts-dark-2.png 1152w", "/static/aa7be887e76fef4dd29e89f779a0c12a/0b124/alts-dark-2.png 1728w", "/static/aa7be887e76fef4dd29e89f779a0c12a/0c3f5/alts-dark-2.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.086206896551724%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAA1UlEQVQI11XOP0/CUByFYUY1DhLa29+9t1eqLbEEgtABE+OfVpImhhAXJ6Ksxmh0Yemim1/BEXY+5Et1MQ5nOicnT6NvxxzblEB7ONMhcWcYI6ggYBz3iF2EiMK0U8I4w+ifTvCSE3QYIvXO932UUr9plJNvJsUzNmpykcyoihWDUR9tDJvXLxbTewI5YFg+MX1b0+1EKGtx7wtOL89ph46W5/0d7j/McTcFfqvJdZrxUT5yeFSrasVnVVHkOXu7O1zd3jF/WaJrkVhNvpzRzXqIkn/CLVsUW7UEbF3UAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/aa7be887e76fef4dd29e89f779a0c12a/3cbba/alts-dark-2.png",
              "srcSet": ["/static/aa7be887e76fef4dd29e89f779a0c12a/7fc1e/alts-dark-2.png 288w", "/static/aa7be887e76fef4dd29e89f779a0c12a/a5df1/alts-dark-2.png 576w", "/static/aa7be887e76fef4dd29e89f779a0c12a/3cbba/alts-dark-2.png 1152w", "/static/aa7be887e76fef4dd29e89f779a0c12a/0b124/alts-dark-2.png 1728w", "/static/aa7be887e76fef4dd29e89f779a0c12a/0c3f5/alts-dark-2.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <Title mdxType="Title">3-Color</Title>
    <Row mdxType="Row">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "187.5%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/a919557b97e6325e1378b8aa0ce1be95/a5df1/alts-dark-3sm.png",
              "srcSet": ["/static/a919557b97e6325e1378b8aa0ce1be95/7fc1e/alts-dark-3sm.png 288w", "/static/a919557b97e6325e1378b8aa0ce1be95/a5df1/alts-dark-3sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "19.827586206896548%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAAAsSAAALEgHS3X78AAABEUlEQVQY01WPz0vCcADFvdcYc9/9cq4pLtRyIkXZXKZSiEVCBEJUsA5hUocKih2kDhFBl4rOdehf6B/8ND0UHR48Ho/3I+U7a3jZMropcDIexVyDTMZC0zS8YoCbL6FraWy3wny1h5O10XUdbbFKtuBhmcbUO9EmSHXW32hvDLHmZFbcLjfhB36tgqUL3Oid2k6Eo0q4QY/w6oVKuZgU6Fijffxui5ztIIT4C/Qfn6hHJ2iKzO5qi+/4ldJCGUOoLN890zg4xpQVmnttxl/3FPIFhKpy9vnA1qCfFJv/Fx5d3NLp9ZFmZwgbAeM4Ti7bKGmF0WHMZnMbSZZoBiGXw3MMw5guGpxes1QPE67+hk3wA2pIfc5I/rrtAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/31fbdd51481c10ab2601322cb7e37536/3cbba/alts-dark-3.png",
              "srcSet": ["/static/31fbdd51481c10ab2601322cb7e37536/7fc1e/alts-dark-3.png 288w", "/static/31fbdd51481c10ab2601322cb7e37536/a5df1/alts-dark-3.png 576w", "/static/31fbdd51481c10ab2601322cb7e37536/3cbba/alts-dark-3.png 1152w", "/static/31fbdd51481c10ab2601322cb7e37536/0b124/alts-dark-3.png 1728w", "/static/31fbdd51481c10ab2601322cb7e37536/0c3f5/alts-dark-3.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "19.827586206896548%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAAAsSAAALEgHS3X78AAABEUlEQVQY01WPz0vCcADFvdcYc9/9cq4pLtRyIkXZXKZSiEVCBEJUsA5hUocKih2kDhFBl4rOdehf6B/8ND0UHR48Ho/3I+U7a3jZMropcDIexVyDTMZC0zS8YoCbL6FraWy3wny1h5O10XUdbbFKtuBhmcbUO9EmSHXW32hvDLHmZFbcLjfhB36tgqUL3Oid2k6Eo0q4QY/w6oVKuZgU6Fijffxui5ztIIT4C/Qfn6hHJ2iKzO5qi+/4ldJCGUOoLN890zg4xpQVmnttxl/3FPIFhKpy9vnA1qCfFJv/Fx5d3NLp9ZFmZwgbAeM4Ti7bKGmF0WHMZnMbSZZoBiGXw3MMw5guGpxes1QPE67+hk3wA2pIfc5I/rrtAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/31fbdd51481c10ab2601322cb7e37536/3cbba/alts-dark-3.png",
              "srcSet": ["/static/31fbdd51481c10ab2601322cb7e37536/7fc1e/alts-dark-3.png 288w", "/static/31fbdd51481c10ab2601322cb7e37536/a5df1/alts-dark-3.png 576w", "/static/31fbdd51481c10ab2601322cb7e37536/3cbba/alts-dark-3.png 1152w", "/static/31fbdd51481c10ab2601322cb7e37536/0b124/alts-dark-3.png 1728w", "/static/31fbdd51481c10ab2601322cb7e37536/0c3f5/alts-dark-3.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <Title mdxType="Title">4-Color</Title>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.55555555555554%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAfCAYAAADnTu3OAAAACXBIWXMAAAsSAAALEgHS3X78AAAE90lEQVRIx51Va0xbZRiuGOImLS2059L29EJpgZa2lHJnUGiBQtmG25RNxgAhW5zJdBu4ualTZ8xUFjWZyTIRdQs4M00wWcYuKGyajOFiNGRRooSZZYnx9sP98Jc/Ht/vgyK3CNjkO6fnfO95zvu87/M+RyWKIgwGAYJBhCRKYNeLF+0LIvQUJ4rykjGCIPCzih0CQS88fhf0QjL0ej29wMAX+88C9XoDMpwOFFCc3SJDn6oj8PkxcVAClBBMr0WR62F4LVWwWCxQFIUvm80Go9EEgz4FFmcAWSWNcAQboDiyYbMqMJsVWK3W+RlKBjOO1N7CiShwsHASwWAQ0WgUtbW1CIfDyMjIgk7zADIjexE+9jeqjgPB9U9jQyyCcKQKlZWVkCTpX0BZJMCCH9ATAl7IuwOPx4OysnXweX1ISUmBKBFF7RpkR59H/ZtAjAA94aeQF3CjPFQBh8PBac9SlkQjYpWn0LT+c2wIv8epmkwmTt1oNEKgkhh0athD25FzaBj+rkuwl2yCWTJAsViJtnk2O56hQDcST7yKhNErSDj7LgKBAKqqqlBdU0N0M5BKhZeStdBu3YLEiwNIvHoRwiObES0vRzWVprCwcAEgZZPY24OEsVEC7IfX60WEaldWVga73U6dFyBpNFDvaIZq9Auorl+DYdtWhPLyUEFxOTk58wFFWYbz9W5kfnQO6cff4DTZBqPCqAtUcEOyBraGLfCePgdPTx9s0Rjk1FRI9Gy8RLNNMSsWvPbBeQxN/oXey99wynV1dQiFQsjPzyfBC9Bok9Cy6QmMnf0Z4wP30N64ByXrirkaaqg0BQUFXJMc0ERaOnPjR3wL4JPvfuNdLi0tRf5MkCwbkaReg92tR3BnDHy1bdsHf4BKQ7JhXU6lbGe7LBPFQ+9cwNufTeG53ks8fWWGLguSSDZqTRKatzyOkY8ncbHvFh6qe5QmJZWUYKUXyvNrKBkVeBr7UXTgLnztIzy7SCTCqbAGsSzV1JSdj7Vi4usbuDtxC7t3dmAdNa26upqXhet1LmDFsz+hoRcIH/0TPp+PAzJgVnA2BWvWrsWLhw8j/numsxOB3FyUlJTw5sXrNz3LkhHB5jMofXIUwR0f8i6zIEaFBckEqFar0dLUhOtDQ7g6OIjNGzdCR1mxuLlzPK1DukjRaZCiVXMTYNfsjXMdhJ3ZeGm1Wuh0ulmHia9F9pXtyYY7K4v7IdtgNJfyOnZ/4d6iDNnBRVJxut0QZzrLZBCvy8IH/useB9QzgF0duP9gJ+5rb+VNCbE5pQ7yWZ7R2EqXSk8UNAf2Q9V9DKq9e+D3+7kPlhOoy+WataYVA7JZ1XS04cGDXUja2c4FzRbr9lzjXDEg01pfTw+mxsdxZeBTLlSWHdNhWlra6jO0EOD3N29ywf5++zb/BLApySXh/q8MGbXhC4P4dWoKX16+zAXNsmbn+EitBlQlmRRk7X8fwVMTyH5pkLtNcXER8shAWbarpiyZLPCenEDhKODr/4ODxGIxXken0zlPjysCFMnv3EeH4ev9BZkvX5v+QM24MKO8cLSWBZTN9NV7axfaRl7BptP74KaJYZ1mbsI6PddNVtYUxYiWC504fO8kdn11hH8C6uvruYWxSVlooMvX0Chj+8B+7JnoRvP5LljJhdPT05HmSFvSdZavIR0Ulw1WTxosGXYOwuZ3bndXk+E/pwPLvkbG8wcAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/87c1723b3b3f1145171e382379bd84be/a5df1/alts-dark-4sm.png",
              "srcSet": ["/static/87c1723b3b3f1145171e382379bd84be/7fc1e/alts-dark-4sm.png 288w", "/static/87c1723b3b3f1145171e382379bd84be/a5df1/alts-dark-4sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.66447368421053%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsSAAALEgHS3X78AAABqUlEQVQoz3WSTWsTURSGsyqNaDIzma9kTDpJJ2ZyZzJ3dMRIraIiJXFRtRLcleJKdBM/kC5ERFwUFN2pBUEQwVVx5VIorqQI7v0Bgogf/+DxGmxETBeXAy/nPuc9LydneQV0XcMwDCzLwrZtap6qpSKapmOZ5kj3ymUCz8PQ9X96t+v2y60kL4hFh0QmVNQnS4nyzH2SU0Oy/TG1GR+zqOGEIVMXBjTSlEREE2Ej4GrvM1IeoBW2xg3d6+/JltfJZJuaX8csFLAVqHTvLuGROWSkgI4zGZjbeInMMjpxjKnWG4lPHpJfvcqcTKk3GkxNT7PYW4CfXxicO8uM7/8HGgMvbW7RSSRCiPHEi482OH9tjSQKEVFMcXeeZH6BW2+/cuhEH9Fq4rjuZIevP35T+UmaQfDHocObxx94cPMZ+8JAuWlg7slT6fZovvpOeLRP3AqwdwIeu/OD7GBXrRxRUkBHZbP1bpPn609ptwXVWhVtVwFxMmX4aY3Dp+dJY0nFq0wGRv3beHuruO7fkIdXLjNYWho5/j2gpBn48SzHbyxSb89Sdtwdz+YXPwr2t57rrNMAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/1d6546a696da9de0a986e36b187107e1/3cbba/alts-dark-4.png",
              "srcSet": ["/static/1d6546a696da9de0a986e36b187107e1/7fc1e/alts-dark-4.png 288w", "/static/1d6546a696da9de0a986e36b187107e1/a5df1/alts-dark-4.png 576w", "/static/1d6546a696da9de0a986e36b187107e1/3cbba/alts-dark-4.png 1152w", "/static/1d6546a696da9de0a986e36b187107e1/92c65/alts-dark-4.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.66447368421053%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsSAAALEgHS3X78AAABqUlEQVQoz3WSTWsTURSGsyqNaDIzma9kTDpJJ2ZyZzJ3dMRIraIiJXFRtRLcleJKdBM/kC5ERFwUFN2pBUEQwVVx5VIorqQI7v0Bgogf/+DxGmxETBeXAy/nPuc9LydneQV0XcMwDCzLwrZtap6qpSKapmOZ5kj3ymUCz8PQ9X96t+v2y60kL4hFh0QmVNQnS4nyzH2SU0Oy/TG1GR+zqOGEIVMXBjTSlEREE2Ej4GrvM1IeoBW2xg3d6+/JltfJZJuaX8csFLAVqHTvLuGROWSkgI4zGZjbeInMMjpxjKnWG4lPHpJfvcqcTKk3GkxNT7PYW4CfXxicO8uM7/8HGgMvbW7RSSRCiPHEi482OH9tjSQKEVFMcXeeZH6BW2+/cuhEH9Fq4rjuZIevP35T+UmaQfDHocObxx94cPMZ+8JAuWlg7slT6fZovvpOeLRP3AqwdwIeu/OD7GBXrRxRUkBHZbP1bpPn609ptwXVWhVtVwFxMmX4aY3Dp+dJY0nFq0wGRv3beHuruO7fkIdXLjNYWho5/j2gpBn48SzHbyxSb89Sdtwdz+YXPwr2t57rrNMAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/1d6546a696da9de0a986e36b187107e1/3cbba/alts-dark-4.png",
              "srcSet": ["/static/1d6546a696da9de0a986e36b187107e1/7fc1e/alts-dark-4.png 288w", "/static/1d6546a696da9de0a986e36b187107e1/a5df1/alts-dark-4.png 576w", "/static/1d6546a696da9de0a986e36b187107e1/3cbba/alts-dark-4.png 1152w", "/static/1d6546a696da9de0a986e36b187107e1/92c65/alts-dark-4.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <Title mdxType="Title">5-Color</Title>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "94.44444444444444%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAAAsSAAALEgHS3X78AAAEG0lEQVQ4y2WUa0xbZRzG55ZgGJfez+npDSgOYZS2lLa0tGvplQrohmzGCRtjEg1qMBHdZjIcJrLEmW0xfpnMZS5T0Rk10egwM4iDuaAhyzQLXhLnJUv8YpRvfvv5nsNKwDU5PW/Pefr8/8/zf953gyRJmE0WzGYJSZJRf995WbBYJExmy23MnTiLxaLdN6hf/oCHRm8dJkkniM2rl8lk0oAmsb6ntoZQi5cal4LZqNeercUUSTXC5to84S09eJxpHHYHTqcTu91OVVUVNptNKDDgcHuoj/TiDtwv1l5cToeGUbHrOpTNNg7nv+PVHBxq/QVvk4/CfQVyuTzpdJqtjR505XdTFxskM/Ev2eMQ2D5OV0eKVDpDJpPRiq4SWiUbY+EfeT0J48FbNG71EI/H8Pl8GI1GJNmKSVdKffsInYKs8wR4CmMEvPeSbE9RV1enyV6VLEsK3dsm6S/MsCNxDofDKSoq4u5AURQsYgBmfTlVQm7zgRn8o5dwJ/qwySbsjhVr1km2iAclJ4+yae4zNr7zBl6/n3QqRTabpaGhAaOoLut06LsKlHzyPiWzFzH27yYTbSObzxOJRJBleQ2h0F9yepJNC1fZ+N4UHq+XrPAlkUjgdrsxCaBcUUFlbw93zc+yYeEKhv37SLS0kBK4YDD4v9hYrVS9fIyaqXdxHT+BIgpI4qVqtGa2Wr2yEnuhky1vTlF75i2cD/RgNRqQxX9VjGZNkdAuvJo48xGfLv3D5PQifiE5L6TE43HC4bAGrNSV05Pv4/L537j24TLDfQdojYSELTmRhhxtbW0aThuKTeTu7PwPLAIfLP2Fp6lJm3LrbW+sYsplFaXs2TnCza/h1rfw1OA4Tb5GLVr19fXrp2y1Khw5O83p+d956e0ZbWrqVcyWSlheUUZv1wBfXrjJpamfeaTncTEsvQi3a91AVoKtOGjcdY7IqAj14Beisyjt7Ukt1E2iW3V7VQgPdz24g+tX5/j1xnWefnKYSDRKSqRBnbKW17WE8YM/0T0J7S8u4/X5hZSsNmV166kdlG7ezMjwMMXP0SPjNAcCJLYlqK6u1oquEkqyQmzoY9KCNPrYNKqnqlx1gkVvysrK6N/9MEvXFvn+mwWG9g2g0+s1a4oHyaqHDquNqYee549nznN58BV8Xh8dHR0kE0lisRiJZAKb2E1N3SEGPj/I0JUXiO3PEfYHhT2tRIX0UCiEwWBY6dCh2LjxxCk4tsDfz13ALyR3FARhMqkFu9pdg6nCQHhvimf/fI1Dy6dIj24nFoySEdaoMVt3OChiihf3TmgdzooO1eNL3ceqf6pks8WMoVxPYGeMobkxHv3qMOE9KeziUKkRBVXZ62KjLtQuq2wOXIp99dAsgopA2SqjOMWucNm0dRGz1j/1/h+BpoTqVVfBUQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/82abcc7f01c0417bc7b1c06a8f3f2d1f/a5df1/alts-dark-5sm.png",
              "srcSet": ["/static/82abcc7f01c0417bc7b1c06a8f3f2d1f/7fc1e/alts-dark-5sm.png 288w", "/static/82abcc7f01c0417bc7b1c06a8f3f2d1f/a5df1/alts-dark-5sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "44.73684210526316%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABY0lEQVQoz5XRu0rDABTGcR1Fo8Rc2vSKmKQ2oUlr4w2CWixWEPFGFwVBLDgJUgeRinPxARxFEcXNxc0X0EGxYHERX+WvBmdNhwOHM/z4Pk5XLKkRSciIoogsyyiKgqZFSSUiSIMikiSjqmpw/5mf/a/pKpu71HLXWJaFbdsoskjKnGBy6w5nvIJtmSi/4H9YAPqTR2xWn3DzLsO6jjQgkHBncZrvuKVV7BEDWVFDYQHYs71J9+UZhUIBM5NBEgSkcY/u23PMhXny2WxnCdf3D2k+POI4DoZhMPCdcNSb4eyizVx5mVzOIh5PhAeXdk44vmpTLI6iD+v0Cb1MT5V4uf9gbamKYRqonVQ2yg3G9lpB5YxpIgj9lGam+Xx7ZX11hXQ6HRoLwEalRqt+g+d5OK5LVI6Q9R3qz6f4yyUcK0dU08JXXnF9TuY2SCaTaLEYkiiRsobwDxbR3QxxLfb9FCV0wi/EjwivozXSJgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/67a1bf3dacb32a3dcd7b017c72332cab/3cbba/alts-dark-5.png",
              "srcSet": ["/static/67a1bf3dacb32a3dcd7b017c72332cab/7fc1e/alts-dark-5.png 288w", "/static/67a1bf3dacb32a3dcd7b017c72332cab/a5df1/alts-dark-5.png 576w", "/static/67a1bf3dacb32a3dcd7b017c72332cab/3cbba/alts-dark-5.png 1152w", "/static/67a1bf3dacb32a3dcd7b017c72332cab/92c65/alts-dark-5.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "44.73684210526316%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABY0lEQVQoz5XRu0rDABTGcR1Fo8Rc2vSKmKQ2oUlr4w2CWixWEPFGFwVBLDgJUgeRinPxARxFEcXNxc0X0EGxYHERX+WvBmdNhwOHM/z4Pk5XLKkRSciIoogsyyiKgqZFSSUiSIMikiSjqmpw/5mf/a/pKpu71HLXWJaFbdsoskjKnGBy6w5nvIJtmSi/4H9YAPqTR2xWn3DzLsO6jjQgkHBncZrvuKVV7BEDWVFDYQHYs71J9+UZhUIBM5NBEgSkcY/u23PMhXny2WxnCdf3D2k+POI4DoZhMPCdcNSb4eyizVx5mVzOIh5PhAeXdk44vmpTLI6iD+v0Cb1MT5V4uf9gbamKYRqonVQ2yg3G9lpB5YxpIgj9lGam+Xx7ZX11hXQ6HRoLwEalRqt+g+d5OK5LVI6Q9R3qz6f4yyUcK0dU08JXXnF9TuY2SCaTaLEYkiiRsobwDxbR3QxxLfb9FCV0wi/EjwivozXSJgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "1 category option 1",
              "title": "1 category option 1",
              "src": "/static/67a1bf3dacb32a3dcd7b017c72332cab/3cbba/alts-dark-5.png",
              "srcSet": ["/static/67a1bf3dacb32a3dcd7b017c72332cab/7fc1e/alts-dark-5.png 288w", "/static/67a1bf3dacb32a3dcd7b017c72332cab/a5df1/alts-dark-5.png 576w", "/static/67a1bf3dacb32a3dcd7b017c72332cab/3cbba/alts-dark-5.png 1152w", "/static/67a1bf3dacb32a3dcd7b017c72332cab/92c65/alts-dark-5.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h2>{`Sequential palettes`}</h2>
    <h3>{`Monochromatic`}</h3>
    <p>{`The monochromatic palettes are good for relationship charts and trend charts. In light themes, the darkest color denotes the largest values. In dark themes, the lightest color denotes the largest values.`}</p>
    <Title mdxType="Title">Palette 1</Title>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1024px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "57.8125%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAADU0lEQVQozyWSfUzUBRjHf/+0mi424O46EjgOCZQjbGcIBwfK7OTFJIbUdE4Lk4yEDSgYp4fnbJ1ukUtzucXUWlYT8CUjGxqYpJkdeLg47uV3x3GQwY0kIJNxwH36Qc/23efZ8zz7/vE8j+C9G8LXA4u0X1/Afk3itQV62h9y90qA374bp/uyl86L/dy45OD6hT6+b73F1dZfaG/9mUstV7lwvp3LbT8wNTmNcGZ3iC/3hTjzZogPMuawSFrkO4k97I7r4q3427zy7Gk2yA5jUHxIZng9SctK0SzfQeKyYuRPJhPxRCIrwtbgsLsRzpbDV1Vwdk+Io/p5jmbNY8kMUrXaRnnCTfY+d5uSmM/ZqLSQF9WEXtaAJmwbqWE7WfV0CVHL16B4KpnYcK1kKCK0NMzTYpzl6+p5mncFObl1hmNFE7yfJ2LcYKU2+wYVmRd5I/002188QanWQmFqPQZNJbkpZWRpStAmGtClFuJx+xBEt5e/xicgBB7Ry9hoYCkf/XMMn8/PwkKIyckpnA4Xjx79SzA4h9vlZmLib0JSz+8fZmRkhNnZIIsh/O7oZWTUu6S+fiu+YTcPxobod/TRP9DHg1E/TpedXpuVIb8Xj9eNra8X0ePCNzSIzXYPh2MA/7CfQGAMYXvOYUozD/BqtomyokPs2tzIzkITe7eZqdhhpvw1E5VlB6mtOETVHhM1FY00vGemrrqRuhoTpv1mDuw/SH2dEZ0uE+GjbDiiW6ApF87tkw5U+b86muCnT6HzBPS0wUAX9HdI73UHxgch4IaHQzDzDwQfw/TEHBnpOoRPNkLTejieB+erJdVASy10HYdbzdB9Cu5/C2I3ODvBL/3s5LBkJplO/QFzM9LKpfU9noac7PUIxvRBjFkOzAYXlq1Ojr0ucvJtkc/edfFFo5tvjnho+9jFlWYXHec8/Njq5ma7k187RazdIr13nNjve7lntZOWlo5QsKkI7QvrUMWspGDTFrJ0OahVCeToczG8lE/CykTWpWXw8uYiNMkppGiep7i4hLXatSQlrSI/vwC9Xk+8Oh6FQoEQp1Yhk0ciV8hRq+NQKp8hUhZBrCqG6OgVRESEEx0TjUoVK+URKKOU0pwamUyGXC6X6qolRkZGLvE/qduFfqUwdgQAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Monochromatic palette 1",
              "title": "Monochromatic palette 1",
              "src": "/static/b275c6036f149f7c8dbd0e9d7e5e9ef4/2faef/palettes-mono-1sm.png",
              "srcSet": ["/static/b275c6036f149f7c8dbd0e9d7e5e9ef4/7fc1e/palettes-mono-1sm.png 288w", "/static/b275c6036f149f7c8dbd0e9d7e5e9ef4/a5df1/palettes-mono-1sm.png 576w", "/static/b275c6036f149f7c8dbd0e9d7e5e9ef4/2faef/palettes-mono-1sm.png 1024w"],
              "sizes": "(max-width: 1024px) 100vw, 1024px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.94736842105263%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACyElEQVQoz32SW0iTYRjHPyIwIWy6g9t0lcuo1MrSysjMUS7BTIUogsgoCuyiA0Vmzc1jtbbSYpSEF2r6lV4JRQcIjIoi0ZbGIjpaayV2ICtttfn9+lwHu+oPP973eS5+PM/LK/zwS7x7IfG+D/ofS/g8Mg8l+nq/8rznM8/uf+LRvTchPN0v6e16ygMZd5eHrs4ePL2PGAmOMBpJkhDe9Um07JQ4v0eibv0I9owAzuVBdie72Z54i20J18iZ6iA3rgZTbAnz1RtYEL2Z6eplaCcmkpGSx/DQ8Jhw4Dk0boUGmRM5ElUpEmXJ3ymK62FTzA3WRV/ApLCTEVHNvAk7iB+/BuO4AtTj5hMmxDI7LpOhr/8IP/Z/41pjPzfPDdLRMEj7sbdcdn2g7cgTmirdiEfduA5ewWW7iKuinaq99Rwra6Sy5CTFuypwHa/H7/cTDAYJBAIIo+Yh/yB/EmT49y3wtxeQvjGWEf4X4ajDTrXdJmOl8tAoNiqqrJRXylRYsZVbsJWVhii1WmRKsZQexGKxhLDKtcPhwOl0hhB0EQmsi29mrbGZTaktbM8SKVousm+9yIGNIpYtIvb9IkeKRWrKRU4fFznlFKmva6G5qQ2HvZaIiEmEhYURHh6OkGJczWkzuEzQUgiXLHChGDrPgPssPGiVv1M3vOmEwSfyTp/kZ3k/tuLA2y8YjUY0Gg06nQ4h0WDiQFoftqVeDue+4kShl7oiH00lXtqqX9Ne6+Nqg5eOVh+3L76m+7qX3js+PPde8fLZADc67mIwTEapVIakwtQp0zAvK2DOjDRS5yzFnJlH0sxUTOnZZKabmZuUSk52PosXpZO2cAm5q/KZl5xC1oqVmM3ZJMxKCInUavUvoVarxTAlhiiVAp0+Gn2sliilghiDHk20GqUqSp4gVu5FyrUGfYwehWISer0OlUpFZKTir2z0/AmS8Ei+FyTSMgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Monochromatic palette 1",
              "title": "Monochromatic palette 1",
              "src": "/static/8ffa59cc56f83e290fcba819632d3c94/3cbba/palettes-mono-1.png",
              "srcSet": ["/static/8ffa59cc56f83e290fcba819632d3c94/7fc1e/palettes-mono-1.png 288w", "/static/8ffa59cc56f83e290fcba819632d3c94/a5df1/palettes-mono-1.png 576w", "/static/8ffa59cc56f83e290fcba819632d3c94/3cbba/palettes-mono-1.png 1152w", "/static/8ffa59cc56f83e290fcba819632d3c94/92c65/palettes-mono-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.94736842105263%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACyElEQVQoz32SW0iTYRjHPyIwIWy6g9t0lcuo1MrSysjMUS7BTIUogsgoCuyiA0Vmzc1jtbbSYpSEF2r6lV4JRQcIjIoi0ZbGIjpaayV2ICtttfn9+lwHu+oPP973eS5+PM/LK/zwS7x7IfG+D/ofS/g8Mg8l+nq/8rznM8/uf+LRvTchPN0v6e16ygMZd5eHrs4ePL2PGAmOMBpJkhDe9Um07JQ4v0eibv0I9owAzuVBdie72Z54i20J18iZ6iA3rgZTbAnz1RtYEL2Z6eplaCcmkpGSx/DQ8Jhw4Dk0boUGmRM5ElUpEmXJ3ymK62FTzA3WRV/ApLCTEVHNvAk7iB+/BuO4AtTj5hMmxDI7LpOhr/8IP/Z/41pjPzfPDdLRMEj7sbdcdn2g7cgTmirdiEfduA5ewWW7iKuinaq99Rwra6Sy5CTFuypwHa/H7/cTDAYJBAIIo+Yh/yB/EmT49y3wtxeQvjGWEf4X4ajDTrXdJmOl8tAoNiqqrJRXylRYsZVbsJWVhii1WmRKsZQexGKxhLDKtcPhwOl0hhB0EQmsi29mrbGZTaktbM8SKVousm+9yIGNIpYtIvb9IkeKRWrKRU4fFznlFKmva6G5qQ2HvZaIiEmEhYURHh6OkGJczWkzuEzQUgiXLHChGDrPgPssPGiVv1M3vOmEwSfyTp/kZ3k/tuLA2y8YjUY0Gg06nQ4h0WDiQFoftqVeDue+4kShl7oiH00lXtqqX9Ne6+Nqg5eOVh+3L76m+7qX3js+PPde8fLZADc67mIwTEapVIakwtQp0zAvK2DOjDRS5yzFnJlH0sxUTOnZZKabmZuUSk52PosXpZO2cAm5q/KZl5xC1oqVmM3ZJMxKCInUavUvoVarxTAlhiiVAp0+Gn2sliilghiDHk20GqUqSp4gVu5FyrUGfYwehWISer0OlUpFZKTir2z0/AmS8Ei+FyTSMgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Monochromatic palette 1",
              "title": "Monochromatic palette 1",
              "src": "/static/8ffa59cc56f83e290fcba819632d3c94/3cbba/palettes-mono-1.png",
              "srcSet": ["/static/8ffa59cc56f83e290fcba819632d3c94/7fc1e/palettes-mono-1.png 288w", "/static/8ffa59cc56f83e290fcba819632d3c94/a5df1/palettes-mono-1.png 576w", "/static/8ffa59cc56f83e290fcba819632d3c94/3cbba/palettes-mono-1.png 1152w", "/static/8ffa59cc56f83e290fcba819632d3c94/92c65/palettes-mono-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <Title mdxType="Title">Palette 2</Title>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1024px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "57.8125%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAADOElEQVQozzWSf0zUZRzHn/7JtNUccD/k7vDACMoGKfHj6hC68kSByrJwTiYSKyvMGctFHj+yTVnr19JV/1QbfRsDFbcma0Nyc86hu4D0OO7u++U4DvXcnf2AHLQO/L56uNVne+/z/uzZ89qe9+cRgz6d835Y7n3DOr3/6YfzsyjnfkMZ+gPlpxmUsyrKQBjlRz9K/xWUM17ZL6OcHOL73nP0nP6ZP2fvIEo6dFzHdMo6de7dfVdKZ4XswuVHPHUFsWkMUXAK8dAJRN43CPtRRHojwviG7HsQq5yIFWWI1ZVc84cRjiPwbBc4PoD7G3RW7dFZWb+EcAckzIuolMAN/Yj8rxCPSGBOF8L0GmLNWxK6F/FAZQp6T5pLAqcQL36+SN3xJbZ9tETJ4UXWtyTJa/6L7L1RrDt92HZ4sdYOYnGfxPZMN9ZNJ7CUHsFa/D62ogPYChsw5+9g3cZdBNQoIhjSWPg7yXIFgiqzc3dSPjpzg5uxWykfT9xGmwyn/Pz8AqqqkUwm0XWdqUiEWCzG/yVC414SNydJxML4r3q5HgmRuDVNYHyM0MRV4rEooYCPa7+OcGMmQngyxOjIL0yFNaYjYUZHRwhM+IlGp4nH4zLv6g951O3hsSoPlXWdlL/chvMlD7UNHWxv7KCm3sOu19tp3N/J7n0emva3cfBQJ83vtPF2i4dWTwfvHW6n5VArDseTiJWNcF89rG6Cp49JyQW5pJq7obUPWnrg+BD0eqF7GAZ8MC5fOHYdJmQivy/A3D8ylrlFSsocctv74MFXwfQmuD+GLZ/A1k/hoAS1n5HQU/D1BTg9Bj0SOhiAYEJCJUy7LWEy/vm7EjwPzvIKufVXIqTVBclqUClsDuJ8V6WqTaPuaIimz0Ic+FLD851KV0+IL/o1vh1Q6RsKcvaixuCwygVvEK9vkksjfp4oLkVsrnqenNz1ZNpy2FqznYINxZgzs6hwbaa8wiW9lVKHE/eWbdiy7BQUPk7tcy+Ql5dPbu7DVFfXsLGoCIvVislkkv80247JaMBoyGBdTjaZa8ykp6exdm0WNqsl5S2WzNS87M1mM9nyTkZGBgaDAbvdjtFolGfpqflfiYNvYPf4Yz8AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Monochromatic palette 2",
              "title": "Monochromatic palette 2",
              "src": "/static/36cee1d367aede565558a5456e24069e/2faef/palettes-mono-2sm.png",
              "srcSet": ["/static/36cee1d367aede565558a5456e24069e/7fc1e/palettes-mono-2sm.png 288w", "/static/36cee1d367aede565558a5456e24069e/a5df1/palettes-mono-2sm.png 576w", "/static/36cee1d367aede565558a5456e24069e/2faef/palettes-mono-2sm.png 1024w"],
              "sizes": "(max-width: 1024px) 100vw, 1024px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.94736842105263%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACyElEQVQoz32SeUjTYRjH33AxhLK1uc05jxxlaYZZdI0u7bBDO/7ogCKKiLKMCqRzm/NIXZtFh1kU0R/5gwT/KEiosAiiZvc96c45Q//q0Flpv0+vXfZXD3z4Pjy875f3eZ5XhL+qBEKSVnj4TuX2S8krlcamMP5nHZJP+B+1SdrxPwjhv/da8gb/3SZu3HrC/ccv6On5Tm+oqooItKrM9qjkVKqM2qESteY70etUtDkBImbdQ5N1k4j0k2gyTqNJqSAicSOapK30tyxEDJxM8rhVdHZ29Rk+bQF7CUwsgrjNIJZLlnQjpj9HjL+DGH0VYTuBSDiKMBciotYiBqxGaGciRDp620I6OsJ9hs1tYXx17zl2uYuKug/sPN1OcW0n26peUlD1nN3VAfJKGth14DoF5fXkOxQcnjq27D7GpoJK9ledJdz1RbbdQ3e3fEiv87euj/wNNfw7+dJX6unknwP8L4TP68FXXsi+MieevS7KSwspK3ZSWuyixO2k2O2gyO3C7XJQKHE5HTgce3A6pO6R6nTi9Xrx+Xw/EVpDKprJNfSzK5jm1pC6XGHEUoUZ6xXm5yss2qKQV6Swwa2w3aNQcVhh7yGFIydqOHWmljLvQaKiBqHVaomMjJRzTl2APh8GbIB0uZhFx2HeEdh5DkovgrcB6l/A+SZofA+tchLv5AS+/m6xue0zNpsNk8mExWJBRA/NZOCyZvQrQiTnBbHvCDLbHWJlZZBN1S1ySSG5tCDVF0LUNLRQfzPIlbvyPz5uJvC2nUvXGomPT8BgMPw0FYlJQ7FnLcZqG03a2OnYM3OJSxrJlKwcxoyfxvCRGWTPX0xKWgYTJk0he24uKalpZM+Zx9RpmQxLHo7ZbMZoNP4yjIkxMyTRijFah9ViIiEuFoNeR7zUGLORaINe5lZZGywvmrDGWtDpdMTK9kzSZLDM/5j16g/wqDk4GbRVUQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Monochromatic palette 2",
              "title": "Monochromatic palette 2",
              "src": "/static/3fbb1d27ecfb8d373cecdf29268708b0/3cbba/palettes-mono-2.png",
              "srcSet": ["/static/3fbb1d27ecfb8d373cecdf29268708b0/7fc1e/palettes-mono-2.png 288w", "/static/3fbb1d27ecfb8d373cecdf29268708b0/a5df1/palettes-mono-2.png 576w", "/static/3fbb1d27ecfb8d373cecdf29268708b0/3cbba/palettes-mono-2.png 1152w", "/static/3fbb1d27ecfb8d373cecdf29268708b0/92c65/palettes-mono-2.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.94736842105263%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACyElEQVQoz32SeUjTYRjH33AxhLK1uc05jxxlaYZZdI0u7bBDO/7ogCKKiLKMCqRzm/NIXZtFh1kU0R/5gwT/KEiosAiiZvc96c45Q//q0Flpv0+vXfZXD3z4Pjy875f3eZ5XhL+qBEKSVnj4TuX2S8krlcamMP5nHZJP+B+1SdrxPwjhv/da8gb/3SZu3HrC/ccv6On5Tm+oqooItKrM9qjkVKqM2qESteY70etUtDkBImbdQ5N1k4j0k2gyTqNJqSAicSOapK30tyxEDJxM8rhVdHZ29Rk+bQF7CUwsgrjNIJZLlnQjpj9HjL+DGH0VYTuBSDiKMBciotYiBqxGaGciRDp620I6OsJ9hs1tYXx17zl2uYuKug/sPN1OcW0n26peUlD1nN3VAfJKGth14DoF5fXkOxQcnjq27D7GpoJK9ledJdz1RbbdQ3e3fEiv87euj/wNNfw7+dJX6unknwP8L4TP68FXXsi+MieevS7KSwspK3ZSWuyixO2k2O2gyO3C7XJQKHE5HTgce3A6pO6R6nTi9Xrx+Xw/EVpDKprJNfSzK5jm1pC6XGHEUoUZ6xXm5yss2qKQV6Swwa2w3aNQcVhh7yGFIydqOHWmljLvQaKiBqHVaomMjJRzTl2APh8GbIB0uZhFx2HeEdh5DkovgrcB6l/A+SZofA+tchLv5AS+/m6xue0zNpsNk8mExWJBRA/NZOCyZvQrQiTnBbHvCDLbHWJlZZBN1S1ySSG5tCDVF0LUNLRQfzPIlbvyPz5uJvC2nUvXGomPT8BgMPw0FYlJQ7FnLcZqG03a2OnYM3OJSxrJlKwcxoyfxvCRGWTPX0xKWgYTJk0he24uKalpZM+Zx9RpmQxLHo7ZbMZoNP4yjIkxMyTRijFah9ViIiEuFoNeR7zUGLORaINe5lZZGywvmrDGWtDpdMTK9kzSZLDM/5j16g/wqDk4GbRVUQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Monochromatic palette 2",
              "title": "Monochromatic palette 2",
              "src": "/static/3fbb1d27ecfb8d373cecdf29268708b0/3cbba/palettes-mono-2.png",
              "srcSet": ["/static/3fbb1d27ecfb8d373cecdf29268708b0/7fc1e/palettes-mono-2.png 288w", "/static/3fbb1d27ecfb8d373cecdf29268708b0/a5df1/palettes-mono-2.png 576w", "/static/3fbb1d27ecfb8d373cecdf29268708b0/3cbba/palettes-mono-2.png 1152w", "/static/3fbb1d27ecfb8d373cecdf29268708b0/92c65/palettes-mono-2.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h3>{`Diverging palettes`}</h3>
    <p>{`Please note that diverging palettes do not differentiate between light and dark themes.`}</p>
    <h4>{`Palette 1`}</h4>
    <p>{`The red-cyan palette has a natural association with temperature. Use this palette for data representing hot-vs-cold.`}</p>
    <Row mdxType="Row">
      <Column colLg={12} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "90.27777777777777%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsSAAALEgHS3X78AAAD1UlEQVQ4y5WUe0zVZRjHf6HNolmxVBiKlGSWaxrkXFm2RZtbDZ2ZmFuXrct0DEyDbtaMFWRMqTCC6VgmhK1xU4dBSAtLI67BYIpygNM5XM4FQQ4HzuV3eT+95xxq/gGrnu279/fH+/u83+d5n+dVuCGEIRBibnHDOpeUwIZprxdV15gtxH9R4KCZ/UFgT1cXFpMJ1T2F3+VCc7vRJ1wYU9MgD8Mjparg94Ouh2QYIcLf64x7RZU/lKekcXj9Bkoff5Ifnt5Mw2OJDG7diTXxGawvvY5n9xvYs3Lw5RVwvawKV/WP+H5vwdnajrAOYuvvR5dGgg4DwCNPJLL3loV8uTiab2PiOBsVS999DzFw92qcTyXhTUrmevp7qAeymC7+Dk/5afwNF3AFgANmxi0WjImJEFCXqRxe9wh7bg7nq8gYiqOWU7M0jt7oezGvikffvANt2wuQeRCyD0HFGThbB9IhvX1gtsDUFMgyBVPWZF0+f3Rj0GFBdCwly1ZQs3wlptgHMN+fgLrledTnXkRkfoKQQCGBoroO0diCuHI1CBSBdCcnQ7ccAGavXkOqopC74HZKwiM4t3AJlyKWYl7xIKMbNzEp6+nfkxGEcuw4ovwUyJRF9yWM/gE0mw1Vphx0aGgaddmfUrk7lXOp+2hKS6dn79sMyZqNHshm/FAe7qPH8Z0sQ6+uRf/5F/SWP9B7rqJbh9AcTvzXxvDJtMU/fShderTZ+/D/RhA4OGwLyu03cPkMRqd1RqYMrC6dy+OCy2M6nXaVDrufNqubVsskbeZxWk1O2kw2mi+Z6e4fxgg4DFB7bWOYnJP8anFT1mXnxBU/79T+SUazYO3XFhIqfETldHFn7gDLcrpZ8mETt6WcIWbXSRZs/YK47Zms2pmNT9VCwEGXD4tLpdGuUWPxc6LXILPZy74mwZoyL2srdRYdGeKOvGFuPdDOvLcuorxayfzkIsKScrlpQxorkj8KAQMpO3xgk9PVfA3qbVAs2yu7E9IlMF62Xfwpg0UFo0TkO5i3vxUl/QLKK5Uo244FgUrCLuIk0B8CgsMjGJFqHhXUjwhK+gRZHYI3JfBhCUw4pRNZ6OSufDsLPmgjLOMiYa9VEba9iPlbPkNZn8LKHR+HgIFmdLmnGRjz0OLQqB0SHJP9+m6bYGeDYJ0E3lPqZXGBg/CcPpT97Sip51FerkB59ijKpoMo8WlEJr0/U0MJVOX4ubwaTo+82Sl5q3IsA25/GhaclpP1vUmj9LKHbzonKGq9RuFvIxSeN1NY30NhTQf5VY2U1rWiy5dHEXO+grN9/3v8BX78oBld0o+ZAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Diverging palette 1",
              "title": "Diverging palette 1",
              "src": "/static/d5c3d7ca560fd6452d032a39afbe5901/a5df1/palettes-div1sm.png",
              "srcSet": ["/static/d5c3d7ca560fd6452d032a39afbe5901/7fc1e/palettes-div1sm.png 288w", "/static/d5c3d7ca560fd6452d032a39afbe5901/a5df1/palettes-div1sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.948275862068966%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAA6klEQVQI1w3NPy8DYQDA4SNm30Bi6OQT2DuS2msxsJAYyFlNpmIxGJBqwnhhEAkRRCVshuZCxEIaXGmud6++d++9f346PPPj9ZOENIrIu130gI1jXCqwUmKVwmmD0ZosVxTWIQtLohy/meWnb+iIgk6SEcUCIXO8y9oWa94IwViJl/EJ0vI0etlH7x2ib5rY1zfUIProKe6/DbuhpnptKB1LRjffGVppMjx7hDe5ir8T4D0FJzSmZnicW6A9v8Tf+gZmvwEXV9AKcZ9fWCGIpea55zhvQ60Fi3cF1dOIykFIZfuWsl+nfvbAP4pbxBsPfFBcAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Diverging palette 1",
              "title": "Diverging palette 1",
              "src": "/static/b7b8e0abf65bfdbbd255a2e7888fc152/3cbba/palettes-div1.png",
              "srcSet": ["/static/b7b8e0abf65bfdbbd255a2e7888fc152/7fc1e/palettes-div1.png 288w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/a5df1/palettes-div1.png 576w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/3cbba/palettes-div1.png 1152w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/0b124/palettes-div1.png 1728w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/0c3f5/palettes-div1.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.948275862068966%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAA6klEQVQI1w3NPy8DYQDA4SNm30Bi6OQT2DuS2msxsJAYyFlNpmIxGJBqwnhhEAkRRCVshuZCxEIaXGmud6++d++9f346PPPj9ZOENIrIu130gI1jXCqwUmKVwmmD0ZosVxTWIQtLohy/meWnb+iIgk6SEcUCIXO8y9oWa94IwViJl/EJ0vI0etlH7x2ib5rY1zfUIProKe6/DbuhpnptKB1LRjffGVppMjx7hDe5ir8T4D0FJzSmZnicW6A9v8Tf+gZmvwEXV9AKcZ9fWCGIpea55zhvQ60Fi3cF1dOIykFIZfuWsl+nfvbAP4pbxBsPfFBcAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Diverging palette 1",
              "title": "Diverging palette 1",
              "src": "/static/b7b8e0abf65bfdbbd255a2e7888fc152/3cbba/palettes-div1.png",
              "srcSet": ["/static/b7b8e0abf65bfdbbd255a2e7888fc152/7fc1e/palettes-div1.png 288w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/a5df1/palettes-div1.png 576w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/3cbba/palettes-div1.png 1152w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/0b124/palettes-div1.png 1728w", "/static/b7b8e0abf65bfdbbd255a2e7888fc152/0c3f5/palettes-div1.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h4>{`Palette 2`}</h4>
    <p>{`The purple-teal palette is good for data with no temperature associations, such as performance, sales, and rates of change.`}</p>
    <Row mdxType="Row">
      <Column colLg={12} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "90.27777777777777%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsSAAALEgHS3X78AAAD0UlEQVQ4y62SW0xcVRSGD5SKpa/GNjE+aDW10RhT0mC1GixqrIl9qEFFbmmMWttaLFgk3qFQMRIRsIAFKdCrMRY7tFgupagtFpgi98twvw1lpoUZYIYzM+fszz0MxD5Yn7qS/6ydk51v/WutrXBLCCFuI27J/y/Fe9HpdODxuPnvELeVWM5i+d8SsLOth8H+URbmNRyzHtR5nYVZgcsp0FzgUeV1D2iyptD/1WK55bzUheJa8JCZUMm7W38kaVsN6eGtpG/v58RuQWGMh5JEM7+muDmXM8XvR1UaDDM0V9npN6r0XLMwPS4YHpiURjSfQy9w38ulhK1JI/qhMvY+Vk/8411kvij4ZqtG/lszHNurcSZthspMN/U/O2gqd9JzxUVfsx3rsMA8Oo3D7rOqeNwa74QWEXrPQWLXn2XXI5c5sLGHr7cIMl/SOBkHp+OhNgcuHYa2CuisgSEjWAfgxii4HLAwt9SyF/jeC8WErU1j5wYDex69QmJwNxmhErhN40Sc4HSCoCZbUHtY0HJe0FEtGDQKrpvEItAp5+0DSodul0Z0SB6bVx3k1ftOsfOBOj7YYCI5WCUjTONIpM7xPQJDiqA6S3D1JLScE5guw3iHwDKoYbvuwmFb8DnUPDqlGVfI3F9NflIDxZ/28lOyBcMhF1Xf6dQVaPx1SqfZoNNZK0H1OsMtOmaTzo0xHZvFw+xNVb6QJaD3o6pzuNzz3IlYBI6YJxmWmvZoWOVMR1QX3U6VznknRvss12ZsNFlv0GSx0jgxQdP4GMaREZoGBjH2D9DQ1U374CC616GX2mqx0Dozwy9TU2T39XFgdJSQP+rY1NlO0KkTBF04T2BWJn65OazN/pZ701NZnbCf+/fFERjxJusiolgfsxPV7ZYOJbDX4aDL6aTMZqPQaiVhYpwnJWxjRysrK8oJrKxAKfwBpSCflV+lEvDFJyh7dxMQG4t/+Gv4Pfc8D0ZG+4Bem0OaRr+UYX6eErudDyfNPN1vIrijjbsuVnF31W/4lRShFBWgpH6J8lnSIlCJiloEKpu3sC4yRu7B7ZvhkDyYpMrn5iiWLhPNZp7t62WTBK6SwKCqC6yQQH8JXHEoBf/PP8b//T34x8QQ8PobKM+E8nBUrA/ofY3T0lm73UaFhB2ZnuYjOfQdPV08YWxk9aUaFEMZSulRlO+zUNKSURLjUXa9jRIRgfLKdpSQp1izI9zXshfoJd90qYy55HZVlUZZ4KJc0hm5rGLzBPkjQ+T3mciTc837u5nchqvkXv6T3NpacisryTlr4Hh1DZqu+5ZyJ+MfekqoLgW2mv4AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Diverging palette 2",
              "title": "Diverging palette 2",
              "src": "/static/0452a6236da7fee253c879dc39516a2e/a5df1/palettes-div2sm.png",
              "srcSet": ["/static/0452a6236da7fee253c879dc39516a2e/7fc1e/palettes-div2sm.png 288w", "/static/0452a6236da7fee253c879dc39516a2e/a5df1/palettes-div2sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "16.056034482758623%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAA7UlEQVQI1wXBv0rDQADA4VN338B38A0suqm4+QBCBRcXF6vQ1cHNKBREilBQEMW/IKKDglqpQycLoZS6SE0CjUmTSy6Xy8/vE6MgxhuERENN7BfIwJBGBSoxaGUweYHWOVIpUmMItMbLFE6a4EqJG0W4YYjj+0QyQZxYr8xN7rEx3Wa3pKiXNbc7Oc1Tjf2mcXoGf5jxFUsug4CV7z5TrSbjVxeI2gFj1S0mVsuImVmqR3XE83WH7eUbDtd7nFcyniz4PAP7BX468DcoSEaaX5XyHsfUPJe1rs1S64OF+zvmG8cs7luUNis0Hh75B8ISxVKc21lDAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Diverging palette 2",
              "title": "Diverging palette 2",
              "src": "/static/ab9ea8685fd4657fb40902e3885d2f74/3cbba/palettes-div2.png",
              "srcSet": ["/static/ab9ea8685fd4657fb40902e3885d2f74/7fc1e/palettes-div2.png 288w", "/static/ab9ea8685fd4657fb40902e3885d2f74/a5df1/palettes-div2.png 576w", "/static/ab9ea8685fd4657fb40902e3885d2f74/3cbba/palettes-div2.png 1152w", "/static/ab9ea8685fd4657fb40902e3885d2f74/0b124/palettes-div2.png 1728w", "/static/ab9ea8685fd4657fb40902e3885d2f74/0c3f5/palettes-div2.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "16.056034482758623%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAA7UlEQVQI1wXBv0rDQADA4VN338B38A0suqm4+QBCBRcXF6vQ1cHNKBREilBQEMW/IKKDglqpQycLoZS6SE0CjUmTSy6Xy8/vE6MgxhuERENN7BfIwJBGBSoxaGUweYHWOVIpUmMItMbLFE6a4EqJG0W4YYjj+0QyQZxYr8xN7rEx3Wa3pKiXNbc7Oc1Tjf2mcXoGf5jxFUsug4CV7z5TrSbjVxeI2gFj1S0mVsuImVmqR3XE83WH7eUbDtd7nFcyniz4PAP7BX468DcoSEaaX5XyHsfUPJe1rs1S64OF+zvmG8cs7luUNis0Hh75B8ISxVKc21lDAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Diverging palette 2",
              "title": "Diverging palette 2",
              "src": "/static/ab9ea8685fd4657fb40902e3885d2f74/3cbba/palettes-div2.png",
              "srcSet": ["/static/ab9ea8685fd4657fb40902e3885d2f74/7fc1e/palettes-div2.png 288w", "/static/ab9ea8685fd4657fb40902e3885d2f74/a5df1/palettes-div2.png 576w", "/static/ab9ea8685fd4657fb40902e3885d2f74/3cbba/palettes-div2.png 1152w", "/static/ab9ea8685fd4657fb40902e3885d2f74/0b124/palettes-div2.png 1728w", "/static/ab9ea8685fd4657fb40902e3885d2f74/0c3f5/palettes-div2.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h2>{`Alert palette`}</h2>
    <p>{`Alert colors are used to reflect status. Typically, red represents danger or error; orange represents a serious warning; yellow represents a regular warning, and green represents normal or success.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "102.77777777777777%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAACXBIWXMAAAsSAAALEgHS3X78AAADRElEQVQ4y52Va2xTZRiAGxL/GIzbkC5cuhVBIQiEf45ACAyEOLwlagQSFQg/IPzAH0YzSmALt2ACiTHqRAYJGm+EGGFjWzam21AuYYzb2nPKutLC2DIGa097GL2c8/j2dIU6Bpl7kydv+53zPef9vvN+OTaeEuYgQ8eeFjbTMNBPn0GrriVSW2+hVdWgn2uFbje012AqDeBpwHTXwfUWDM1L/E61UCOcTOfeExixHhEmEvgXvY4nZyLqhKnCNDzP2Qm88yEcd8HndszyGVD2MubWAvhiITHPXkJ/5Qjj0zTl03/qWUtuCW8sewslfwpe50y8U2aivOAg+P46qNoOLgfmrjmwczZm2UuwbykxZR+h5nzCzZMHKSD0Zy7xvtosoX1Q6EwLA5ZwG2wR4U4R7pj1uLApJZskOIYIl7+NIsv1vviKMAvVXkjwg/WYUqHpKpQK51pSs3w67F8mwv0inCBIZSILtzhl6eNEWJcWBhcuRx2bz3W7EyXPgfuZ5/GXrJQ9LIXP8mD7NNnDqbL8ibC7iLhnD5HmsUSaciXnojXl0V8/RvawCpuRTHLrl6MEvzlAoOIgoZ+P0n/kJ6KnmtGVFsKN36H//SP3Gg+itxyWt17LQO8Fetxf0adW0Kt8S6izknj3DxgDN6VC0+SiqtLW2cEFr4qR1VNe/01Ot17jTFs7l1Q/Xfei1njvXY3zrSoXL/u4dNVPT9/Awx61pX50BYIEfZ2Cn+SDGCTT7dvTfRtP+zUCft+jtjYNtHCI211B/FJENBq2rhhG3LpmVRiN6WgPokQkR+M6EeF+YuDR6ZB7DDkAqZyJ1P/MWGY8lW0JI8m6ehfzflvN4mNrLIp+XcWGxvKHZy8zKXti9sOGCBO89vt67N8voPDwUpzC+APzefPEpscmZU980kMs4YrjGyk4tITpR0osJlcW82715v8IRxqW8A0RFlrCFcwQHIeKea/6k9ELi4+tJafiVSZVLpLqFpNbUUTJHxtGK0zi+udLPmooZU39Fj6uK2VVzaeUnf16dMLUzapb4WrbFXzeDnxqx7Bv8H8JfZ0+2t1uFEVBi2jpPntCm4xIqOvSzJGIRVLO9nC9NmLhsN+SUVSWiX8BqOKr09nLolcAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Alert palette",
              "title": "Alert palette",
              "src": "/static/a405e134333b2095b675dfa3bf12bb40/a5df1/palettes-alert-sm.png",
              "srcSet": ["/static/a405e134333b2095b675dfa3bf12bb40/7fc1e/palettes-alert-sm.png 288w", "/static/a405e134333b2095b675dfa3bf12bb40/a5df1/palettes-alert-sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "26.973684210526315%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAAsSAAALEgHS3X78AAABFElEQVQY032PPSwDcRiHm1gsJqJLEyyCicFosVgMEpNBrBarbkg6CIlEYpBc4mMyidSGVDpIU219DEcvbUNPRBCtvztc7/vhOpiqT/Iu7y+/580bcvVPjOwF3+kczn0Bnq5BvcQTCraWAS3Hoyhx/iJz9XqL4dQI8H2fRoQCWbFnACXci4jOwPow/uIgZmKKSioC6T5Wk7OEt8YY2pugINR60fO9xsJaOkupPcJNSwdibhLW+mG+C/toHJFqg7NOYolpWqURundGyVfvmgv1soocW+Ztc5v3kzgPhyt8nUpoyj7FzBJmWSKZj7NwvMGufICw9OYvW65LxbYIYut3noVBcNtwoPrh1veu6eNo5l/pP1nAD9VeXg5gt+VaAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Alert palette",
              "title": "Alert palette",
              "src": "/static/5f2df4eef146bf9713d2d4d7a2a162f9/3cbba/palettes-alert.png",
              "srcSet": ["/static/5f2df4eef146bf9713d2d4d7a2a162f9/7fc1e/palettes-alert.png 288w", "/static/5f2df4eef146bf9713d2d4d7a2a162f9/a5df1/palettes-alert.png 576w", "/static/5f2df4eef146bf9713d2d4d7a2a162f9/3cbba/palettes-alert.png 1152w", "/static/5f2df4eef146bf9713d2d4d7a2a162f9/92c65/palettes-alert.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "26.973684210526315%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAAsSAAALEgHS3X78AAABFElEQVQY032PPSwDcRiHm1gsJqJLEyyCicFosVgMEpNBrBarbkg6CIlEYpBc4mMyidSGVDpIU219DEcvbUNPRBCtvztc7/vhOpiqT/Iu7y+/580bcvVPjOwF3+kczn0Bnq5BvcQTCraWAS3Hoyhx/iJz9XqL4dQI8H2fRoQCWbFnACXci4jOwPow/uIgZmKKSioC6T5Wk7OEt8YY2pugINR60fO9xsJaOkupPcJNSwdibhLW+mG+C/toHJFqg7NOYolpWqURundGyVfvmgv1soocW+Ztc5v3kzgPhyt8nUpoyj7FzBJmWSKZj7NwvMGufICw9OYvW65LxbYIYut3noVBcNtwoPrh1veu6eNo5l/pP1nAD9VeXg5gt+VaAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Alert palette",
              "title": "Alert palette",
              "src": "/static/5f2df4eef146bf9713d2d4d7a2a162f9/3cbba/palettes-alert.png",
              "srcSet": ["/static/5f2df4eef146bf9713d2d4d7a2a162f9/7fc1e/palettes-alert.png 288w", "/static/5f2df4eef146bf9713d2d4d7a2a162f9/a5df1/palettes-alert.png 576w", "/static/5f2df4eef146bf9713d2d4d7a2a162f9/3cbba/palettes-alert.png 1152w", "/static/5f2df4eef146bf9713d2d4d7a2a162f9/92c65/palettes-alert.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h2>{`Gradient use`}</h2>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` Gradients are not yet supported in Carbon Charts. This exploration is subject to change.`}</p>
    </InlineNotification>
    <p>{`Gradients are good for highlighting extremes in a range of values. Use a gradient on single category visualizations only if needed. Multiple gradients are often inaccessible and are discouraged in our system. Gradients should not be used to represent any meaningful progression or divergence. Never use a gradient in place of a sequential palette.`}</p>
    <p>{`For the full list of approved gradient options, see the IBM Design Language `}<a parentName="p" {...{
        "href": "https://www.ibm.com/design/language/elements/color#gradients"
      }}>{`Color page`}</a>{`.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "98.1907894736842%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAECUlEQVQ4y22SbWhbVRjHL26dW1/SJPc1aRKbptlWk1rKNtvRMXSK+zDQ+UG0A8e+iUNQcOyD+k0ZCHaCEymslRZB+0VFRP2gIMjAqYMxddY6aNlLm7TJzUvzeu9Nnr/nnDTJNj3w4zn3nOf5n/957pFAAIfqQL1OjPsioZkiRq1WQ7FUhmVVUamUUalWQUQtJJbC0qqMOu4dTQmuXG2cyAYXSG4ksXwnhcXlBBLJ9XYFF0wsV3D52wz++MXC9WvA738Sri4Srtwg/LYCXFp28PX1LLJlp1WYyQF/3wLSJXZWzWZOK23BlSvAV1PAlzOEhbk6PvmsjtkvCNPfEC78QHj/EnCO5ayVGq5LRcKNJYJtV1EsbqJcqQpBy7KEqNTuEOG/4649asR8CrCKgO1YMLN5JmSzXtfbgtT6Idw+bf2QNrSlRdQ4kLu5ubqKRHoDt9bWkFhP3dvDarWM3GYGNbL/xx8hu5lDJp9jjpzWmm052PyngMLNPIrlEmpOrS249JNDn58p0I/n8vTzuyZdnUrS4ge3aeWjZUpcXKLUzDUqzf5K9VSBX4SI2Tb/qlAlbRF7QuQ4DhWLRRH5kGzWjyz7m4XbQPEOu9IqwVqrwUk4qCeZ6xTrTarSanHFZGzwx+YgncnCsu3W+xQ9zOZMK18yrVyRkxFkC5yslWGYm5yclTZNK5MxreSqaaU2GKmUtb6+bqXTaQH/NlmOFIvF7Ydjw3aME28Qvx+xHxPEhxlxPo+zGG+vb80lr6sb3q4O9O7aDtfObeh5cBu6GV2Mzh0PoJPPd25Hb68LHo8Hbre7gZj3QpYVeLxescb3pdDIBA09c5r6H3ueIo+/QHufmKT4k5M0+tQJ2n/0BB1++hQ9e/JVikSHSFFkMgyDdF0nXdMEocgeCoTCpKmqWJeU8ePwvzyH6EvTGHnlIsZfm8WR1z/GsbNzeO6Nebz41jxOv72APfF98DBHmqbB5+/D3vgI/OEodH8AejAMla0zUUialyV1d0Dp2gGZXd3T2QF351YLGD27OtDNoix7hZjKivS+EPyhfhg+PwxdE7G5JymqBlnVoeoGNMMn0O9C1fQGLE/T1K2oQWdznbvSdbHO3XGXUiAYwGA0wq5hQFZkKKoikFWZJaiIDEYwwPD5fMJB04miKCK/3x9EwPCLGr4nHYqexNlD3+PMxKd48/A83jkyi/eOTuPDYxcwc/w8FibP47tTUxiLDsPldQtXhqEjHA4j4Asi7B9AyPdQWzBk7EYseAjx0EGM9B/EaHgM+wYexYHIAYwN7sf44Cgmdo8i6OsTRdxdwN+PoegjCDExLtJnhNhBerOHXniUHrgVF9yyC70tepmjBj2MpgNeZLB+cwGdOWXPSNDc+xdCwBkV9sBZdQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Gradient palette",
            "title": "Gradient palette",
            "src": "/static/3539fdf8f971d3e7db1865fd7a1c1093/3cbba/gradient.png",
            "srcSet": ["/static/3539fdf8f971d3e7db1865fd7a1c1093/7fc1e/gradient.png 288w", "/static/3539fdf8f971d3e7db1865fd7a1c1093/a5df1/gradient.png 576w", "/static/3539fdf8f971d3e7db1865fd7a1c1093/3cbba/gradient.png 1152w", "/static/3539fdf8f971d3e7db1865fd7a1c1093/92c65/gradient.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      